import React from 'react';
import { merge } from 'lodash';
import AgoraRTC from 'agora-rtc-sdk-ng';
// import { withRouter } from 'react-router';
import { VideoRecording } from '../../actions/project/index';
import { CountNoParticipant } from '../../actions/project/index';
import { StopVideoRecording } from '../../actions/project/index';
import { removeVideoCall } from '../../actions/project/index';
import { connect } from 'react-redux';
import mixPanel from '../../utils/helpers/mixPanel';
import './canvas.css';
import '../../assets/fonts/css/icons.css';
import { VideoRecordingUserList } from '../../actions/project/index';
import { getUIDDetails } from '../../actions/project/index';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { VideoRecordingUpdate } from '../../actions/project/index';
import { UpdateLayoutVideoRecording } from '../../actions/project/index';
import { RtcTokenBuilder } from '../../actions/project/index';
import maverickPortalhttp from '../../utils/webService/webService';
import maverickPortalApiEndPoint from '../../config/apiEndPoint';
import videoOffNew from '../../assets/images/videoOffNew.svg';
import videoOnNew from '../../assets/images/videoOnNew.svg';
import micOffNew from '../../assets/images/micOffNew.svg';
import micOnNew from '../../assets/images/micOnNew.svg';
// import PulsatingDot from '../../common/PulsatingDot';
// import spearkerOffNew from '../../assets/images/spearkerOffNew.svg';
// import spearkerOnNew from '../../assets/images/spearkerOnNew.svg';
import screenShareNew from '../../assets/images/screenShareNew.svg';
import endCallNew from '../../assets/images/endCallNew.svg';
import { createChannel, createClient } from 'agora-rtm-react';
import { Dropdown } from '../../components/form';
import DownIndicator from '../../common/DownIndicator';
import captionIcon from '../../assets/images/captionIcon.svg';
import captionOffIcon from '../../assets/images/Caption-closed.svg';
import translationIcon from '../../assets/images/translationIcon.svg';
import DropdownIcon from '../../components/form/DropdownIcon';
import { Divider } from '../../common';
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';
import { sendTranscriptData } from '../../actions/transcript/SendTranscriptData';
import {
  saveRtmTranscriptData,
  storeTranscriptLogs,
  storeTranscriptMessageLogs,
  updateSid,
  getParticipant,
  SendParticpantsListOnEnd
} from '../../actions/project/index';
import { requestUpdateVideoLayout } from '../../actions/field/StartInterviewAction';

import moment from 'moment';
import GenerateSumaryModal from '../../common/GenerateSummaryModal';
import '../../common/ReactTooltip.css';
import avatar from '../../images/researcher.png';
import participants from '../../images/participants.png';
import participantsoff from '../../images/participantsoff.png';
import styled from '@emotion/styled';
import { GiNetworkBars } from 'react-icons/gi';
import { ToastContainer, toast } from 'react-toastify';
import './Toast.css';
import 'react-toastify/dist/ReactToastify.css';

import yellowbar from '../../images/yellowbar.png';
import redbar from '../../images/redbar.png';
import ParticipantsPopup from '../AgoraVideoCall/ParticipantsPopup';
import profile_pic from '../../assets/images/profile_pic.png';
import { color, disjoint, dispatch } from 'd3';
import EndInterviewPopup from './EndInterviewPopup';
import { Button, Icon } from '../../common';

var BASE_TIMESTAMP = null; 
var TIME_SET = false;
var start = null;


const tile_canvas = {
  '1': ['span 12/span 24'],
  '2': ['span 12/span 12/13/25', 'span 12/span 12/13/13'],
  '3': ['span 6/span 12', 'span 6/span 12', 'span 6/span 12/7/19'],
  '4': ['span 6/span 12', 'span 6/span 12', 'span 6/span 12', 'span 6/span 12/7/13'],
  '5': [
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 9/span 16/10/21'
  ],
  '6': [
    'span 3/span 4/13/7',
    'span 3/span 4/13/11',
    'span 3/span 4/13/15',
    'span 3/span 4/13/19',
    'span 3/span 4/13/23',
    'span 9/span 16/10/21'
  ],
  '7': [
    'span 3/span 4/13/5',
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 3/span 4/13/25',
    'span 9/span 16/10/21'
  ]
};

const CustomButton = styled(Button)`
  padding: 2px 1rem;
  color: var(--white);
  border: 1px solid var(--deepBlue);
  buttoncolor: var(--sapGreen);
  cursor: pointer;
  width: 65px;
  height: 32px;
  font-size: 16px;
  margin-right: 10px;
`;

const CustomButtont = styled(Button)`
  padding: 3px 1rem;
  color: var(--white);
 
  cursor: pointer;
  fontSize="15px"
                fontWeight="600"
                color="black"
                size="large"
                buttonColor= var(--sapGreen);
`;

const DeviceButtonWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;
const PermissionWarningIcon = styled.span`
  position: absolute;
  top: -10px;
  left: calc(50% + 10px);
  transform: translateX(-50%);
  color: #ff9800;
  font-size: 12px;
  z-index: 1;
  line-height: 1;
  opacity: 0;
  transition: opacity 0.2s ease;
  .ag-btn-group:hover &,
  .ag-btn-group.active & {
    opacity: 1;
  }
`;

const CancelButton = styled(Button)`
  padding: 2px 1rem;
  color: var(--deepBlue);
  border: 1px solid var(--deepBlue);
  buttoncolor: var(--sapGreen);
  cursor: pointer;
  :hover {
    color: var(--deepBlue);
  }
`;

const Badge = styled.div`
  position: absolute;
  top: 2px;
  left: 55%;
  transform: translateX(-50%);
  width: 14px;
  height: 14px;
  border-radius: 7px;
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--greyBlue);
  color: var(--white);
  font-size: 8px;
  font-weight: 500;
  z-index: 1;
`;

var selectedLanguage;

// list of spoken languages
var languages = [
  { label: 'Select Spoken language', value: 'NA' },
  {
    label: selectedLanguage?.value == 'en-IN' ? 'English ' + '                           ✔' : 'English',
    value: 'en-IN'
  },
  {
    label: selectedLanguage?.value == 'hi-IN' ? 'Hindi/हिंदी' + '                        ✔' : 'Hindi/हिंदी',
    value: 'hi-IN'
  },
  { label: selectedLanguage?.value == 'ta-IN' ? 'Tamil/தமிழ்' + '                  ✔' : 'Tamil/தமிழ்', value: 'ta-IN' },
  {
    label: selectedLanguage?.value == 'mr-IN' ? 'Marathi/मराठी' + '                  ✔' : 'Marathi/मराठी',
    value: 'mr-IN'
  },
  // {label: 'Malayalam/മലയാളം', value: 'ml-IN'},
  { label: selectedLanguage?.value == 'kn-IN' ? 'Kannada/ಕನ್ನಡ' + '            ✔' : 'Kannada/ಕನ್ನಡ', value: 'kn-IN' },
  // {label: 'Gujarati/ગુજરાતી', value: 'gu-IN'},
  { label: selectedLanguage?.value == 'te-IN' ? 'Telugu/తెలుగు' + '           ✔' : 'Telugu/తెలుగు', value: 'te-IN' }
];

const setLanguage = lang => {
  selectedLanguage = lang;
  // console.log(selectedLanguage?.value);
  languages = [
    { label: 'Select Spoken language', value: 'NA' },
    {
      label: selectedLanguage?.value == 'en-IN' ? 'English ' + '                           ✔' : 'English',
      value: 'en-IN'
    },
    {
      label: selectedLanguage?.value == 'hi-IN' ? 'Hindi/हिंदी' + '                        ✔' : 'Hindi/हिंदी',
      value: 'hi-IN'
    },
    {
      label: selectedLanguage?.value == 'ta-IN' ? 'Tamil/தமிழ்' + '                  ✔' : 'Tamil/தமிழ்',
      value: 'ta-IN'
    },
    {
      label: selectedLanguage?.value == 'mr-IN' ? 'Marathi/मराठी' + '                  ✔' : 'Marathi/मराठी',
      value: 'mr-IN'
    },
    // {label: 'Malayalam/മലയാളം', value: 'ml-IN'},
    { label: selectedLanguage?.value == 'kn-IN' ? 'Kannada/ಕನ್ನಡ' + '            ✔' : 'Kannada/ಕನ್ನಡ', value: 'kn-IN' },

    { label: selectedLanguage?.value == 'te-IN' ? 'Telugu/తెలుగు' + '           ✔' : 'Telugu/తెలుగు', value: 'te-IN' },
    { label: selectedLanguage?.value == 'bn-IN' ? 'Bengali/বাংলা' + '           ✔' : 'Bengali/বাংলা', value: 'bn-IN' }

    // {label: 'Gujarati/ગુજરાતી', value: 'gu-IN'},
  ];
};

// const SPEECH_KEY = '896ae8a6c1c84cff9956584ce61c7646';
// const SPEECH_REGION = 'eastasia';/
const SPEECH_KEY = process.env.REACT_APP_SPEECH_KEY;
const SPEECH_REGION = process.env.REACT_APP_SPEECH_REGION;

const messageBoxColor = ['#EB4D4D', '#FAD702', '#798E8F'];

const DownIndicatorCustom = ({ ...props }) => {
  return <DownIndicator color="var(--sapGreen)" iconStyle={{ fontSize: 16 }} {...props} />;
};

var fieldData = '';
var resumeData = '';
const getFieldData = data => {
  fieldData = data;
};

const getResumeData = data => {
  // console.log(data);
  resumeData = data;
};

/**
 * @prop appId uid
 * @prop transcode attendeeMode videoProfile channel baseMode
 */

function mapStateToProps(state) {
  const userId = state.LoginReducer.userId;
  const email = state.LoginReducer.emailAddress;

  window.$emailId = email; //global variable
  window.$user = userId; //global variable

  const screenResolution =
    state.ProjectReducer.getResolution != null && state.ProjectReducer.getResolution[1] != undefined
      ? state.ProjectReducer.getResolution[1]
      : '480p_1';
  const videoResolution =
    state.ProjectReducer.getResolution != null && state.ProjectReducer.getResolution[0] != undefined
      ? state.ProjectReducer.getResolution[0]
      : '640 X 480';
  window.$shareScreenResolution = screenResolution; //global variable
  window.$videoScreenResolution = videoResolution; //global variable
  const getUIDData = state.ProjectReducer.getUIDData;
  window.$getUIDData = getUIDData;
  const rtcTokenBuilder = state.ProjectReducer.rtcTokenBuilder;
  window.$rtcTokenBuilder = rtcTokenBuilder;

  const fieldData = state.GetFieldOverviewReducer.fieldData;
  const resumeData = state.ProjectReducer.resumeData;
  const startInterviewResponse = state.StartInterviewReducer.data;
  const startInterviewLastUpdated = state.StartInterviewReducer.lastUpdated;
  const captureGuideLastUpdated = state.GetCaptureGuideReducer.lastUpdated;
  const isRecordingStart = state.GetCaptureGuideReducer.captureguideData?.isRecordingStart;

  const Guest = state.ProjectReducer.getParticipant;
  window.$Guest = Guest;

  getFieldData(fieldData);
  getResumeData(resumeData);
  return {
    startInterviewResponse: startInterviewResponse,
    startInterviewLastUpdated: startInterviewLastUpdated,
    isRecordingStart: isRecordingStart,
    captureGuideLastUpdated: captureGuideLastUpdated
  };
}



function validateTimeline(transcripts) {
  if (!transcripts.length) return;

  const first = moment.utc(transcripts[0].start);

  const last = moment.utc(
    transcripts[transcripts.length - 1].end
  );

  const totalMs = last.diff(first);

}


class AgoraCanvas extends React.Component {
  translationRecognizer = sdk.TranslationRecognizer;
  USER_ID = Math.floor(Math.random() * 1000000001).toString();
  resetCount = 0;

  constructor(props) {
    super(props);
    if (typeof this.props.micinit === 'undefined') {
      console.warn('micinit prop is undefined, using default value false.');
    }

    this.client = {};
    this.localStream = {};
    this.shareClient = {};
    this.shareStream = {};
    this.state = {
      displayMode: 'pip',
      streamList: [],
      readyState: true,
      stateSharing: false,
      userName: '',
      userid: window.$user,
      selectedLanguage: this.props?.selectedLanguage,
      isRecordingStart: null,
      isSpeaker: this.props.micinit,
      transcriptData: [],
      TranslationLanguage: false,
      startTranslation: false,
      currentLanguage: 'Select',
      myLanguage: '',
      senderId: '',
      transcriptionResults: '',
      languageData: [],
      displayData: [],
      participantsName: [],
      ParticipantsData: [],
      translationStop: true,
      rtmStop: false,
      errorMsgTime: 0,
      participants: 0,
      networkQuality: 100,
      showModal: false,
      isMicMuted: !this.props.micinit,
      isreconnecting: false,
      showPopup: false,
      // active: !this.props.micinit
      active: false,
      networkIconPath: {
        redbar: redbar,
        yellowbar: yellowbar
      },
      showParticipantsBefore: false,
      showPrimaryResearcherModal: false,
      cameraPermissionDenied: false,
      microphonePermissionDenied: false
    };
    this.startInterviewData = null;
    this.translationRecognizer = null;
    this.uid = '';
    this.localTracks = {
      videoTrack: null,
      audioTrack: null,
      screenVideoTrack: null,
      screenAudioTrack: null
    };

    this.timerId = null;
    this.remoteUsers = {};
    this.client = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });

    this.localTrackState = {
      videoTrackMuted: !this.props.videoinit,
      audioTrackMuted: !this.props.micinit
    };
    this.uidarray = [];
    this.screenshareId;
    this.transcriptionTimeoutId = null;
    
    // Track primary researcher join status for secondary researchers
    this.primaryResearcherJoined = false;
    this.primaryResearcherCheckTimer = null;
    this.primaryResearcherToastId = null;
    this.primaryResearcherToastShown = false;
    this.cachedPrimaryResearcherName = null;

    /** Raw rows from fetchResearcherName — used for participant list and primary researcher name. */
    this.participantListRaw = null;
    
    // Network quality toast tracking
    this.toastId = null;
    this.toastTimeoutId = null;

    // Track first transcript creation
    this.isFirstTranscript = true;
    this.previousUplinkQuality = null;
    this.networkCooldownTimer = null;
    this.poorToastCooldownActive = false;
    this.hasShownInitialPoorNetworkToast = false; // First poor toast vs "still poor" message (matches RN)
    this.isInPoorNetwork = false;
    this.isNoInternet = false;
    this.poorNetworkStreak = 0;
    this.POOR_STREAK_THRESHOLD = 3; // require consecutive poor readings before toasting

    //create rtc client
    this.rtmClient = null;
    this.rtmChannel = null;

    this.handleTogglePopup = this.handleTogglePopup.bind(this);
    this.handleClosePopup = this.handleClosePopup.bind(this);
    this.handleToggleParticipants = this.handleToggleParticipants.bind(this);
    this.handleToggleParticipantsImage = this.handleToggleParticipantsImage.bind(this);
    this.handleMic = this.handleMic.bind(this);
    this.handleCamera = this.handleCamera.bind(this);
  }

  handleToggleParticipantsImage = () => {
    this.setState(prevState => ({
      showParticipantsBefore: !prevState.showParticipantsBefore
    }));
  };
  handleToggleParticipants = () => {
    this.setState({ showAllParticipants: !this.state.showAllParticipants });
  };

  handleTogglePopup = async () => {
    const { showPopup } = this.state;
    if (!showPopup) {
      await this.fetchParticipantsData();
      this.setState({ showPopup: true });
    }
  };

  handleClosePopup() {
    this.setState({ showPopup: false, showParticipantsBefore: false });
  }

  isRespondentView = () =>
    localStorage.getItem('user') === 'respondent' ||
    this.props.respondantInfo?.isRead == 1 ||
    String(this.uid) === '1500' ||
    String(this.uid) === '1000';

  getRespondentDisplayName = () =>
    (
      this.props.respondantInfo?.RespondentName ||
      this.props.respondantInfo?.name ||
      this.state.userName ||
      ''
    ).trim();

 

  getLocalCaptionDisplayName = () => {
      if (this.isRespondentView()) {
        return this.getRespondentDisplayName();
      }
      return (this.state.userName || '').trim();
    };

 

    getPrimaryResearcherDisplayName = () => {
    const trimName = name => (name || '').trim();
    const isValidName = name => {
      const trimmed = trimName(name);
      return trimmed && trimmed.toUpperCase() !== 'UNASSIGNED';
    };
    const currentUserId = String(this.state.userid || window.$user || '');
    const primaryResearcherId = this.props.respondantInfo?.primaryResearcherID;

    const fromRespondant = trimName(this.props.respondantInfo?.primaryResearcherName);
    if (isValidName(fromRespondant)) {
      return fromRespondant;
    }

    const fieldRows = fieldData?.FieldOverview;
    if (Array.isArray(fieldRows)) {
      const scheduleId = this.props.respondantInfo?.InterviewSchedule_ID;
      const respondentId = this.props.respondantInfo?.projectRespondent_ID;
      const fieldRow = fieldRows.find(row =>
        (scheduleId != null && String(row.InterviewSchedule_ID) === String(scheduleId)) ||
        (respondentId != null && String(row.projectRespondent_ID) === String(respondentId))
      );
      const fromField = trimName(fieldRow?.primaryResearcherName);
      if (isValidName(fromField)) {
        return fromField;
      }
    }

    const researchers = resumeData?.researcher_data;
    if (primaryResearcherId && Array.isArray(researchers)) {
      const rosterMatch = researchers.find(researcher =>
        String(researcher.user_ID || researcher.researcher_ID || researcher.id || researcher.value) ===
        String(primaryResearcherId)
      );
      const fromRoster = trimName(rosterMatch?.name || rosterMatch?.user || rosterMatch?.label);
      if (fromRoster) {
        return fromRoster;
      }
    }

    if (isValidName(this.cachedPrimaryResearcherName)) {
      return this.cachedPrimaryResearcherName;
    }

    const list = this.participantListRaw || window.$Guest?.fetchResearcherName || [];
    if (Array.isArray(list)) {
      const primary = list.find(participant => {
        const uid = participant?.uid != null ? String(participant.uid) : '';
        const role = (participant?.role || participant?.roleName || '').toString().toLowerCase();
        const participantUserId = String(
          participant?.user_ID || participant?.researcherId || participant?.researcher_ID || participant?.userId || ''
        );
        if (participantUserId && participantUserId === currentUserId) {
          return false;
        }
        return uid === '240000' || role === 'primaryresearcher' || role === 'primary researcher';
      });
      const fromList = trimName(primary?.researcherName || primary?.name);
      if (fromList) {
        return fromList;
      }
    }

    return 'Primary researcher';
  };

  resolveIncomingCaptionName = rawName => {
    if (rawName == null || rawName === '') return '';
    return String(rawName).trim();
  };

  mapParticipantRowDisplayName = p => {
    if (!p) return '';
    return String(p.researcherName || p.name || '').trim();
  };

  mapParticipantsToDisplayNames = list => {
    if (!Array.isArray(list)) return [];
    return list.map(row => ({
      ...row,
      researcherName: this.mapParticipantRowDisplayName(row)
    }));
  };

  fetchParticipantsData = async () => {
    try {
      const data = {
        channelName: this.props.channel,
        user_ID: this.state.userid
      };
      this.props.getParticipant(data);
      // dispatch(getParticipant(data));
      // Saga updates Redux one tick later; read after microtask so fetchResearcherName is populated.
      setTimeout(() => {
        const Guest = window.$Guest;
        const raw = Guest?.fetchResearcherName;
        this.participantListRaw = Array.isArray(raw) ? [...raw] : [];
        const processedData = this.mapParticipantsToDisplayNames(raw);
        this.setState({
          ParticipantsData: processedData
        });
      }, 100);
    } catch (error) {
      console.error('Failed to fetch participants data:', error);
    }
  };

  // Check if primary researcher is present in the channel
  checkPrimaryResearcherPresence = async () => {
    try {
      // Fetch latest participant data
      await this.fetchParticipantsData();
      
      // Wait a bit for the data to be available
      setTimeout(() => {
        const Guest = window.$Guest;
        const participantsData = Guest?.fetchResearcherName;
        
        // Check if primary researcher (uid 240000) is in the participant list
        // The participant data structure may vary, so we check multiple possible fields
        let primaryResearcherFound = false;
        
        if (participantsData && Array.isArray(participantsData)) {
          // Check if any participant has uid 240000 or is marked as primary researcher
          primaryResearcherFound = participantsData.some(participant => {
            return participant.uid === '240000' || 
                   participant.uid === 240000 ||
                   participant.role === 'primaryResearcher' ||
                   participant.isPrimaryResearcher === true;
          });
        }
        
        // Also check if primary researcher is in remoteUsers (has published media)
        const primaryResearcherInRemoteUsers = this.remoteUsers && this.remoteUsers['240000'];
        
        // Also check if primary researcher is in uidarray
        const primaryResearcherInUidArray = this.uidarray['PrimaryResearcher'] === '240000';
        
        const primaryResearcherPresent = primaryResearcherFound || 
                                         primaryResearcherInRemoteUsers || 
                                         primaryResearcherInUidArray ||
                                         this.primaryResearcherJoined;
        
        // console.log('Primary Researcher Presence Check:', {
        //   inParticipantData: primaryResearcherFound,
        //   inRemoteUsers: primaryResearcherInRemoteUsers,
        //   inUidArray: primaryResearcherInUidArray,
        //   alreadyMarked: this.primaryResearcherJoined,
        //   primaryResearcherPresent,
        //   participantsData
        // });
        
        if (primaryResearcherPresent && !this.primaryResearcherJoined) {
          // Primary researcher detected
          this.primaryResearcherJoined = true;
          // Clear any timer
          if (this.primaryResearcherCheckTimer) {
            clearTimeout(this.primaryResearcherCheckTimer);
            this.primaryResearcherCheckTimer = null;
          }
          // Dismiss any active toast
          if (this.primaryResearcherToastId) {
            toast.dismiss(this.primaryResearcherToastId);
            this.primaryResearcherToastId = null;
          }
          // Reset toast shown flag so it can be shown again if needed
          this.primaryResearcherToastShown = false;
          // Close modal if open
          if (this.state.showPrimaryResearcherModal) {
            this.setState({ showPrimaryResearcherModal: false });
          }
        }
      }, 500);
    } catch (error) {
      console.error('Error checking primary researcher presence:', error);
    }
  };

  async componentWillMount(props) {
    //  const user = window.$user;

    mixPanel.init();
    mixPanel.identify(`${this.props.channel}-${this.state.userid}`);
    AgoraRTC.enableLogUpload(true);
    // AgoraRTC.setLogLevel(AgoraRTC.DEBUG);

    // reset timer for rtm
    this.resetTimer();

    this.setState({
      currentLanguage: this.props.selectedLanguage.label,
      myLanguage: this.props.selectedLanguage.value,
      networkQuality: this.props.networkQuality
    });

    if (this.state.isMicMuted) {
      this.setState({ active: true });
    }

    const user = localStorage.getItem('user');
    let $ = this.props;
    let appid = $.appId;
    let channel = $.channel;
    let certificate = '566f52717c70402b8e2232f6d8be24b7';

    this.client.on('user-published', this.handleUserPublished);
    this.client.on('user-unpublished', this.handleUserUnpublished);
    this.client.on('exception', e => console.log('exception_listener123---->', e));
    // this.client.on('error', this.handleError);

    // get user name
    const userData = localStorage.getItem('userData');
    if (userData) {
      let userName = JSON.parse(userData).user_name;
      this.setState({
        userName: userName
      });
    }

    // start RTM client (translation will start after tracks are published)
    setTimeout(() => {
      this.initRtm(this.props.channel);
      this.sendTurnOn();
    }, 1000);

    try {
      if (this.props.respondantInfo.isInterviewStart == 0) {
        this.uid = Math.floor(100000 + Math.random() * 900000);
        this.uidarray['other'] = this.uid;
      } else if (this.props.respondantInfo.isRead == 1) {
        this.uid = '1500';
        this.uidarray['RespondentOnWeb'] = this.uid;
      } else {
        this.uid = '240000';
        this.uidarray['PrimaryResearcher'] = this.uid;
      }
      localStorage.setItem('UID', this.uid);

      // Check if user is a secondary researcher (isInterviewStart == 0)
      // Secondary researchers should NEVER request camera permission
      const isSecondaryResearcher = this.props.respondantInfo?.isInterviewStart === 0;

      // Join channel first
      this.uid = await this.client.join(appid, channel, null, Number(this.uid));

      // Create tracks separately to identify which permission failed and show specific error
      try {
        this.localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
        this.setState({ microphonePermissionDenied: false });
      } catch (e) {
        this.sendToMixPanel('RTC | Microphone permission denied', 419, `${e}`);
        this.setState({ microphonePermissionDenied: true });
        const micMsg = e?.message || '';
        const isPermDenied = micMsg.toLowerCase().includes('permission') || micMsg.toLowerCase().includes('denied') || (e?.name === 'NotAllowedError');
        toast.error(isPermDenied
          ? 'Microphone permission denied. Please allow microphone access in your browser settings to join the call.'
          : `Microphone error: ${micMsg || 'Please check your microphone and try again.'}`);
      }

      if (!isSecondaryResearcher) {
        try {
          this.localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack({
            encoderConfig: {
              width: 640,
              height: 480,
              frameRate: 30,
              bitrateMin: 400,
              bitrateMax: 800
            },
            optimizationMode: 'detail'
          });
          this.setState({ cameraPermissionDenied: false });
        } catch (e) {
          this.sendToMixPanel('RTC | Camera permission denied', 419, `${e}`);
          this.localTracks.videoTrack = null;
          this.setState({ cameraPermissionDenied: true });
          const camMsg = e?.message || '';
          const isPermDenied = camMsg.toLowerCase().includes('permission') || camMsg.toLowerCase().includes('denied') || (e?.name === 'NotAllowedError');
          toast.error(isPermDenied
            ? 'Camera permission denied. Please allow camera access in your browser settings to join the call.'
            : `Camera error: ${camMsg || 'Please check your camera and try again.'}`);
        }
      } else {
        this.localTracks.videoTrack = null;
      }

      if (this.uid) {
        this.state.uid = this.uid;
        this.sendToMixPanel('RTC | Join Channel', 418, 'RTC channel joined');

        //   // this.handleCamera();

        const customerKey = process.env.REACT_APP_AGORA_CUSTOMERKEY;
        // Customer secret
        const customerSecret = process.env.REACT_APP_AGORA_CUSTOMERSECRET;
        // Concatenate customer key and customer secret and use base64 to encode the concatenated string
        const plainCredential = customerKey + ':' + customerSecret;
        // Encode with base64
        const encodedCredential = Buffer.from(plainCredential).toString('base64');
        const authorizationField = 'Basic ' + encodedCredential;
        const newuid = String(this.uid);
        const channelName = this.props.channel;

        const data = {
          cname: this.props.channel,
          newuid: String(this.uid),
          uid: '3613483512',
          clientRequest: {
            resourceExpiredHour: 24,
            scene: 0
          }
        };

        const InterviewSchedule_ID = localStorage.getItem('InterviewSchedule_ID');

        const payload = {
          user_ID: window.$user,
          emailID: window.$emailId,
          uid: newuid,
          interviewSchedule_ID: InterviewSchedule_ID
        };

        const { CountNoParticipant } = this.props;
        CountNoParticipant(payload);
        // dispatch(CountNoParticipant(payload));

        const { VideoRecording } = this.props;
        const { updateSid } = this.props;

        if (this.uid == '240000') {
          // VideoRecording(data, authorizationField, newuid);

          var today = new Date(),
            time =
              today.getFullYear().toString() +
              '-' +
              (today.getMonth() + 1).toString().padStart(2, '0') +
              '-' +
              today
                .getDate()
                .toString()
                .padStart(2, '0') +
              ' ' +
              today
                .getHours()
                .toString()
                .padStart(2, '0') +
              ':' +
              today
                .getMinutes()
                .toString()
                .padStart(2, '0') +
              ':' +
              today
                .getSeconds()
                .toString()
                .padStart(2, '0');

          const data2 = {
            user_ID: this.state.userid,
            startTime: time,
            videoTask_ID: this.props.respondantInfo?.videoTask_ID,
            projectRespondent_ID: this.props.respondantInfo?.projectRespondent_ID,
            projectRepondentVideo_ID: localStorage.projectRepondentVideo_ID
          };
        }

        const payload1 = {
          user_ID: window.$user,
          interviewSchedule_ID: InterviewSchedule_ID
        };

        let _this = this;
        const { getUIDDetails } = this.props;
        this.client.on('connection-state-change', async (state, prevState, reason) => {
          this.sendToMixPanel(
            'RTC | Connection State Changed',
            417,
            `Connection state changed: ${state}, reason: ${reason}`
          );

          if (state === 'DISCONNECTING') {
            this.sendToMixPanel('RTC | Left Channel', 420, `User left, reason: ${reason}`);
          }
        });

        // check network quality
        this.client.on('network-quality', quality => {
          const txQuality = quality.uplinkNetworkQuality;
          const isGood = txQuality <= 2; // 0, 1, 2 (unknown, excellent, good)
          const isPoor = txQuality === 3 || txQuality === 4 || txQuality === 5; // 3, 4, 5 (poor, bad, very bad)
          const isNoInternetNow = txQuality === 6; // 6 (down)

          if (isGood) {
            this.isInPoorNetwork = false;
            this.isNoInternet = false;
            this.poorNetworkStreak = 0;

            this.setState({ networkQuality: quality });
            this.networkQuality = quality;
            return;
          }

          if (isNoInternetNow) {
            this.isNoInternet = true;
            this.isInPoorNetwork = false;
            this.poorNetworkStreak = 0;

            // clear poor cooldown timer
            if (this.networkCooldownTimer) {
              clearTimeout(this.networkCooldownTimer);
              this.networkCooldownTimer = null;
            }

            // allow future poor warnings AFTER internet returns
            this.poorToastCooldownActive = false;

            if (this.state.networkQuality?.uplinkNetworkQuality !== txQuality) {
              this.setState({ networkQuality: quality });
              this.networkQuality = quality;
            }
            return;
          }

          if (isPoor) {
            this.isInPoorNetwork = true;
            this.isNoInternet = false;
            this.poorNetworkStreak += 1;

            this.setState({ networkQuality: quality });
            this.networkQuality = quality;

            // Only toast after a sustained sequence of poor readings
            if (
              this.poorNetworkStreak === this.POOR_STREAK_THRESHOLD &&
              !this.poorToastCooldownActive
            ) {
              this.sendToMixPanel('Network Change', 417, 'Network Quality changed to poor');
              this.showNetworkQualityToast();
              this.poorToastCooldownActive = true;
              if (this.networkCooldownTimer) {
                clearTimeout(this.networkCooldownTimer);
                this.networkCooldownTimer = null;
              }
              this.networkCooldownTimer = setTimeout(() => {
                this.networkCooldownTimer = null;
                this.poorToastCooldownActive = false;
                // Require another sustained poor sequence after cooldown ends
                this.poorNetworkStreak = 0;
              }, 30000); // 30 seconds cooldown
              if (this.toastTimeoutId) {
                clearTimeout(this.toastTimeoutId);
              }
              this.toastTimeoutId = setTimeout(() => {
                this.closeToast();
              }, 5000); // Close toast after 5 seconds
            }
          }
        });
        // var myTimer = setInterval(function() {
        //   getUIDDetails(payload1);

        //   const getUIDData = window.$getUIDData;
        //   console.log('will', getUIDData);

        //   getUIDData != undefined && getUIDData?.length > 0
        //     ? getUIDData?.map(item =>
        //         item.roleName == 'Respondent' ? ((window.$respondantuid = item.uid), clearInterval(myTimer)) : ''
        //       )
        //     : ' ';

        //   const { VideoRecordingUpdate } = _this.props;

        //   setTimeout(function() {
        //     if (window.$respondantuid != null && window.$respondantuid != undefined) {
        //       const streamId = window.$respondantuid;
        //       const data = {
        //         cname: channelName,
        //         uid: '3613483512',
        //         clientRequest: {
        //           streamSubscribe: {
        //             audioUidList: {
        //               subscribeAudioUids: ['#allstream#']
        //             },
        //             videoUidList: {
        //               subscribeVideoUids: [streamId]
        //             }
        //           }
        //         }
        //       };

        //       VideoRecordingUpdate(data, authorizationField);
        //       clearInterval(myTimer);
        //     } else {
        //       const data = {
        //         cname: channelName,
        //         uid: '3613483512',
        //         clientRequest: {
        //           streamSubscribe: {
        //             audioUidList: {
        //               subscribeAudioUids: ['#allstream#']
        //             },
        //             videoUidList: {
        //               subscribeVideoUids: [newuid]
        //             }
        //           }
        //         }
        //       };

        //       VideoRecordingUpdate(data, authorizationField);
        //     }
        //   }, 10000);
        // }, 5000);

        //Update video recording start
        // const resource = {
        //   cname: this.props.channel,
        //   uid: '3613483512',
        //   clientRequest: {
        //     mixedVideoLayout: 3,
        //     // "backgroundColor": "#FF0000",
        //     layoutConfig: [
        //       {
        //         uid: `${this.uid}` == '1500' ? '1500' : '1000',
        //         x_axis: 0.0,
        //         y_axis: 0.0,
        //         width: 1.0,
        //         height: 1.0,
        //         alpha: 1.0,
        //         render_mode: 1
        //       }
        //     ]
        //   }
        // };
        // const { UpdateLayoutVideoRecording } = this.props;
        // UpdateLayoutVideoRecording(resource, authorizationField);
        //END
      }
      let canvas = document.querySelector('#ag-canvas');
      let dom = document.querySelector('#ag-item-' + this.uid);
      // console.log("dom", dom);
      if (!dom) {
        dom = document.createElement('section1');
        dom.setAttribute('id', 'ag-item-' + this.uid);
        dom.setAttribute('class', 'ag-item');
        // dom.onClick=hello();

        if (localStorage.getItem('user') == 'respondent') {
          // dom.setAttribute(
          //   'style',
          //   'grid-area: span 3/span 4/4/5;z-index:3;width:calc(100% - 12px);height:calc(100% - 20px);margin-top: 45px;'
          // );
          dom.setAttribute('class', `researcherBox 1`);
        }
        canvas.appendChild(dom);
        //this.localTracks.videoTrack.play("ag-item-" + uid , {fit: "contain"});
      }
      if (this.uid == '240000') {
        // Researcher side logic
        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        let dom3 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);

        if (localStorage.getItem('user') == 'researcher') {
          // Researcher is alone - show researcher camera in full screen
          if (dom3 == null) {
            // Force remove any existing class and styles first
            dom2.removeAttribute('class');
            dom2.removeAttribute('style');
            
            // Apply full screen style
            dom2.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
          } else {
            // Respondent joined after researcher - show respondent in full screen, researcher in small box
            dom3.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
            dom2.setAttribute('class', 'researcherBox');
            dom2.removeAttribute('style'); // Remove any existing inline styles
          }
        }
      } else if (this.uid == '1500') {
        // Respondent side logic
        let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
        let domResearcher = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);

        if (localStorage.getItem('user') == 'respondent') {
          // Respondent is alone - show respondent camera in full screen
          if (domResearcher == null) {
            dom1.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
          } else {
            // Researcher joined after respondent - show researcher in full screen, respondent in small box
            domResearcher.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
            dom1.setAttribute('class', 'respondentBox');
          }
        }
      } else {
        let dom1 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom1 != null) console.log('2');
        dom1.setAttribute(
          'style',
          `grid-area: span 3/span 4/4/2;
                  z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
        );
      }
      // Only play video track if it exists (secondary researchers don't have video track)
      if (this.localTracks.videoTrack) {
        let videoPosition = 'absolute';
        if (this.uid == '1500') {
          videoPosition = 'relative';
        }
        this.localTracks.videoTrack.play('ag-item-' + this.uid, { fit: 'cover', position: videoPosition });
      }

      // Build publish array from available tracks (some may be null if permission was denied)
      const tracksToPublish = [this.localTracks.videoTrack, this.localTracks.audioTrack].filter(Boolean);
      if (tracksToPublish.length > 0) {
        if (this.localTracks.videoTrack) this.localTracks.videoTrack.setEnabled(this.props.videoinit);
        if (this.localTracks.audioTrack) this.localTracks.audioTrack.setEnabled(this.props.micinit);
        await this.client.publish(tracksToPublish);
      }

      if (document.querySelector('#ag-item-' + this.uidarray['other'])) {
        let dom = document.querySelector('#ag-item-' + this.uidarray['other']);
        dom.setAttribute('style', `display: none`);
      }

      // Call updateCameraViews to ensure proper camera layout
      setTimeout(() => {
        this.updateCameraViews();
      }, 500);

      // CRITICAL: Start translation AFTER tracks are published to avoid microphone conflicts
      // Wait additional time to ensure microphone is fully ready
      setTimeout(() => {
        if (this.localTracks.audioTrack && this.localTracks.audioTrack.enabled) {
          this.startTranslation('Initialized Transcription - After Track Publish');
        } else {
          // Retry after additional delay
          setTimeout(() => {
            if (this.localTracks.audioTrack) {
              this.startTranslation('Initialized Transcription - Delayed Start');
            }
          }, 2000);
        }
      }, 3000); // Wait 3 seconds after publish to ensure mic is fully ready
      
      // Check if secondary researcher joined before primary researcher
      if (this.props.respondantInfo?.isInterviewStart === 0) {
        // First, check for primary researcher presence via RTM and participant data
        // This check happens immediately and also after RTM is ready
        const performPrimaryResearcherCheck = async () => {
          // IMPORTANT: Wait for RTM to be fully connected before checking
          // This ensures we can receive presence messages from primary researcher
          if (this.rtmClient && this.rtmClient.connectionState !== 'CONNECTED') {
            // Wait a bit more and retry
            setTimeout(async () => {
              await performPrimaryResearcherCheck();
            }, 1000);
            return;
          }
          
          // Check participant data and RTM presence - do this multiple times to be thorough
          await this.checkPrimaryResearcherPresence();
          // Wait a bit and check again to ensure we catch any delayed presence messages
          await new Promise(resolve => setTimeout(resolve, 500));
          await this.checkPrimaryResearcherPresence();
          
          // Helper function to check if primary researcher has joined
          // This includes checks for: RTM presence, participant data, media publishing, and uidarray
          const checkPrimaryResearcherJoined = () => {
            const primaryResearcherInUidArray = this.uidarray['PrimaryResearcher'] === '240000';
            const primaryResearcherInRemoteUsers = this.remoteUsers && this.remoteUsers['240000'];
            // this.primaryResearcherJoined is set by:
            // 1. RTM presence message handler
            // 2. checkPrimaryResearcherPresence (participant data check)
            // 3. handleUserPublished (media publishing)
            const primaryResearcherAlreadyJoined = primaryResearcherInUidArray || 
                                                   primaryResearcherInRemoteUsers || 
                                                   this.primaryResearcherJoined;
            
            // console.log('Primary Researcher Check (comprehensive):', {
            //   primaryResearcherInUidArray,
            //   primaryResearcherInRemoteUsers,
            //   primaryResearcherJoined: this.primaryResearcherJoined,
            //   primaryResearcherAlreadyJoined,
            //   rtmConnected: this.rtmClient?.connectionState === 'CONNECTED',
            //   remoteUsers: this.remoteUsers,
            //   uidarray: this.uidarray,
            //   allRemoteUserIds: Object.keys(this.remoteUsers || {})
            // });
            
            return primaryResearcherAlreadyJoined;
          };
          
          // Check if primary researcher has already joined
          const primaryResearcherAlreadyJoined = checkPrimaryResearcherJoined();
          
          // Only show toast and set timer if primary researcher hasn't joined yet
          
          if (!primaryResearcherAlreadyJoined && !this.primaryResearcherToastShown) {
            
            this.primaryResearcherToastShown = true;
            // Show first toast message
            this.showPrimaryResearcherNotJoinedToast();
            // Set up 5-minute timer to show popup
            this.primaryResearcherCheckTimer = setTimeout(async () => {
              // Final check before showing popup - verify primary researcher still hasn't joined
              // Re-check participant data one more time before showing popup
              await this.checkPrimaryResearcherPresence();
              
              // Double-check all conditions to ensure primary researcher hasn't joined
              const primaryResearcherInUidArray = this.uidarray['PrimaryResearcher'] === '240000';
              const primaryResearcherInRemoteUsers = this.remoteUsers && this.remoteUsers['240000'];
              const primaryResearcherHasJoined = this.primaryResearcherJoined || 
                                                 primaryResearcherInUidArray || 
                                                 primaryResearcherInRemoteUsers;
              
              // Only show popup if primary researcher has NOT joined
              if (!primaryResearcherHasJoined) {
                this.showPrimaryResearcherStillNotJoinedToast();
              } else {
                // Dismiss toast if it's still active
                if (this.primaryResearcherToastId) {
                  toast.dismiss(this.primaryResearcherToastId);
                  this.primaryResearcherToastId = null;
                }
              }
            }, 5 * 60 * 1000); // 5 minutes
          }
        };
        
        // Wait for RTM to be initialized and fully connected before checking
        // RTM is initialized 1 second after componentWillMount
        // We need to wait longer to ensure:
        // 1. RTM is fully connected
        // 2. Presence messages can be sent/received
        // 3. Participant data is fetched
        // 4. Any existing primary researcher's presence is detected
        setTimeout(async () => {
          await performPrimaryResearcherCheck();
        }, 6000); // Wait 6 seconds to allow RTM to fully initialize and presence messages to be sent/received
        
        // Also check again after a longer delay to catch any edge cases
        setTimeout(async () => {
          if (!this.primaryResearcherJoined && !this.primaryResearcherToastShown) {
            await performPrimaryResearcherCheck();
          }
        }, 10000);
      }
    } catch (e) {
      this.sendToMixPanel('RTC | Publish Failed', 422, `RTC channel publish failed - ${e}`);
      const errMsg = (e?.message || String(e)).toLowerCase();
      let toastMsg = 'Oops! Something went wrong. Please try joining again.';
      if (errMsg.includes('microphone') || errMsg.includes('audio')) {
        toastMsg = 'Microphone error. Please allow microphone access in your browser settings.';
      } else if (errMsg.includes('camera') || errMsg.includes('video')) {
        toastMsg = 'Camera error. Please allow camera access in your browser settings.';
      } else if (errMsg.includes('permission') || errMsg.includes('denied') || errMsg.includes('notallowed')) {
        toastMsg = 'Media permission denied. Please allow camera and microphone access in your browser settings.';
      }
      toast.error(toastMsg);
    }
    //});
  }
  

  startTranslation = async reason => {
    // CRITICAL: Ensure audio track is ready before starting Microsoft Speech SDK
    // This prevents the "Cannot read properties of null" error
   
    if (!this.localTracks.audioTrack) {
      return;
    }

    // Additional delay to ensure microphone is fully released and ready
    await new Promise(r => setTimeout(r, 500));

    if (this.state.myLanguage != '') {
      //   const transcriptObj = {
      //     text: 'Please turn on CC..!!',
      //     name: this.state.Username,
      //     language: this.state.myLanguage.split('-')[0],
      //   };
      //  this.sendMsg(JSON.stringify(transcriptObj));
      this.getTranslationRecognizer(this.state.myLanguage, reason);
    } else {
      this.getTranslationRecognizer('hi-IN', reason);
      this.setState({ currentLanguage: 'Hindi', myLanguage: 'hi-IN' });
    }
  };

  startSendMessage = async () => {
    if(BASE_TIMESTAMP == null)[
      BASE_TIMESTAMP = moment.utc()
    ]   
    const startTime = BASE_TIMESTAMP;
    
    const parsedMsg = {
      start: startTime.format(
        'YYYY-MM-DD HH:mm:ss.SSS'
      ),
      end: startTime.format(
        'YYYY-MM-DD HH:mm:ss.SSS'
      ), 
      offset: 0,
      duration: '0',
      text: '',
      recognized: true,
      language: 'en',
      name: this.getLocalCaptionDisplayName()
    };

    // Mark that first transcript has been created
    if (this.isFirstTranscript) {
      this.isFirstTranscript = false;
    }

    const { saveRtmTranscriptData } = this.props;
    const InterviewSchedule_ID = localStorage.getItem('InterviewSchedule_ID');
    const transcriptPayload = {
      user_ID: window.$user,
      emailID: window.$emailId,
      uid: String(this.uid),
      InterviewSchedule_ID: InterviewSchedule_ID,
      transcript_data: parsedMsg,
      channel_name: this.props.channel
    };
    await saveRtmTranscriptData(transcriptPayload);
    //await dispatch(saveRtmTranscriptData(transcriptPayload))
  };

  // // send rtm message
  // sendMsg = async text => {
  //   if (this.rtmClient?.connectionState == 'CONNECTED') {
  //     let message = this.rtmClient.createMessage({ text, messageType: 'TEXT' });
  //     await this.rtmChannel
  //       .sendMessage(message)
  //       .then(async () => {
  //         console.log('RTC message send successfully', text);
  //         const parsedMsg = JSON.parse(text);
  //         let hasKey = parsedMsg.hasOwnProperty('recognized');
  //         if (hasKey && parsedMsg.recognized) {
  //           const { saveRtmTranscriptData } = this.props;
  //           const InterviewSchedule_ID = localStorage.getItem('InterviewSchedule_ID');
  //           const transcriptPayload = {
  //             user_ID: window.$user,
  //             emailID: window.$emailId,
  //             uid: String(this.uid),
  //             InterviewSchedule_ID: InterviewSchedule_ID,
  //             transcript_data: parsedMsg,
  //             channel_name: this.props.channel
  //           };
  //           console.log('RTC message failed', e);
  //           const logData = {
  //             respondentId: this.state.userid,
  //             respondentName: this.state.userName,
  //             // researcherId: responseObj.researcherId,
  //             // researcherName: responseObj.researcherName,
  //             channelId: this.props.channel,
  //             reason: "Working",
  //             createdAt: new Date().toISOString(),
  //           };
  //           console.log("Testing log in positive" , logData)
  //           await saveRtmTranscriptData(transcriptPayload);
  //         }
  //       })
  //       .catch(e => {
  //         console.log('RTC message failed', e);
  //         const logData = {
  //           respondentId: this.state.userid,
  //           respondentName: this.state.userName,
  //           // researcherId: responseObj.researcherId,
  //           // researcherName: responseObj.researcherName,
  //           channelId: this.props.channel,
  //           reason: "Recognition session canceled and message is not send",
  //           createdAt: new Date().toISOString(),
  //         };
  //         console.log("Testing log if break" , logData)
  //         const msg = JSON.parse(text);
  //         console.log("In break " ,msg)
  //         if (msg.text == 'Please turn on CC..!!') {
  //           console.log("in if " ,msg)
  //           this.sendMsg(text);
  //         }
  //       });
  //   }
  // };

  sendMsg = async text => {
    try {
      //without if condition sendMSG not working
      if (this.rtmClient?.connectionState === 'CONNECTED') {
        let message = this.rtmClient.createMessage({ text, messageType: 'TEXT' });

        await this.rtmChannel.sendMessage(message);
        this.sendToMixPanel(
          'RTM | Send Message Success',
          201,
          'SendMsg - Log ' + text
        );

        // console.log('RTC message send successfully', text);
        if (this.resetCount > 8) {
          this.resetCount = 0;
        }


        const parsedMsg = JSON.parse(text);
        let hasKey = parsedMsg.hasOwnProperty('recognized');

        this.sendToMixPanel(
          'Recognizer | parsedMsg',
          201,
          parsedMsg
        );


        console.log('parsedMsg', parsedMsg, hasKey && parsedMsg.recognized && this.uid == '240000');
        // send message only in case of primary user
        if (hasKey && parsedMsg.recognized && this.uid == '240000') {
          const { saveRtmTranscriptData } = this.props;
          const InterviewSchedule_ID = localStorage.getItem('InterviewSchedule_ID');

          const transcriptPayload = {
            user_ID: window.$user,
            emailID: window.$emailId,
            uid: String(this.uid),
            InterviewSchedule_ID: InterviewSchedule_ID,
            transcript_data: parsedMsg,
            channel_name: this.props.channel
          };

          // const logData = {
          //   respondentId: this.props.respondantInfo.Respondent_ID,
          //   respondentName: this.props.respondantInfo.RespondentName,
          //   researcherId: this.state.userid,
          //   researcherName: this.state.userName,
          //   channelId: this.props.channel,
          //   reason: "Message are sent!",
          // };
          // console.log("In sendMsg  messsage send to respondent" , logData)
          // this.sendMessageDataAPi(logData);
          await saveRtmTranscriptData(transcriptPayload);
        }
      } else {
        const currentTimestamp = new Date().getTime();
        if (this.state.errorMsgTime > currentTimestamp + 60000) {
          this.setState({ errorMsgTime: currentTimestamp });
          this.sendToMixPanel(
            'RTM | Send Message Error',
            201,
            'SendMsg - Message are not send with error ' + this.rtmClient?.connectionState
          );
        }
      }
    } catch (e) {
      const logData = {
        respondentId: this.props.respondantInfo?.Respondent_ID,
        respondentName: this.props.respondantInfo.RespondentName,
        researcherId: this.state.userid,
        researcherName: this.state.userName,
        channelId: this.props.channel,
        reason: 'Message are not send with error ' + e
      };


      // this.sendMessageDataAPi(logData);
      const currentTimestamp = new Date().getTime();
      if (this.state.errorMsgTime > currentTimestamp + 60000) {
        this.setState({ errorMsgTime: currentTimestamp });
        this.sendToMixPanel('RTM | Send Message Error', 201, 'SendMsg - Message are not send with error ' + e);
      }
      const msg = JSON.parse(text);
      if (msg.text === 'Please turn on CC..!!') {
        await this.sendMsg(text); // Retry the message
      }
    }
  };

  generateTranscriptData = result => {
    const transcriptObj = {
      start: result.start,
      end: result.end,
      text: result.text,
      recognized: result.recognized,
      language: result.language,
      name: this.getLocalCaptionDisplayName()
    };

    this.setState({
      transcriptData: [...this.state.transcriptData, transcriptObj]
    });
    // this.props.sendTranscriptData( sendMsgData.text)
  };

  // getTranslationRecognizer = (sourceLang, reason) => {
  //   if (this.translationRecognizer != null) {
  //     this.translationRecognizer?.stopContinuousRecognitionAsync(() => {
  //       this.translationRecognizer.close();
  //       this.translationRecognizer = null;

  //       setTimeout(() => {
  //         console.log('Delay added');
  //       }, 300);
  //     });
  //   }
  //   const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();

  //   const speechTranslationConfig = sdk.SpeechTranslationConfig.fromSubscription(SPEECH_KEY, SPEECH_REGION);

  //   speechTranslationConfig.speechRecognitionLanguage = sourceLang;
  //   speechTranslationConfig.enableDictation();

  //   for (const languageObj of this.state.languageData) {
  //     if (languageObj.language != '') {
  //       speechTranslationConfig.addTargetLanguage(languageObj.language);
  //     }
  //   }
  //   const existingIndex = this.state.languageData.findIndex(item => item.language === 'en');
  //   if (existingIndex == -1) {
  //     speechTranslationConfig.addTargetLanguage('en');
  //   }

  //   console.log('IN AND OUT');

  //   this.translationRecognizer = new sdk.TranslationRecognizer(speechTranslationConfig, audioConfig);

  //   console.log('IN AND OUT', this.translationRecognizer);

  //   // this.setState({transcriptionResults: ''});
  //   this.translationRecognizer.recognizing = (s, e) => {
  //     console.log('THIS IS TRIGGERED', 'RECOGNIZING');
  //     if (this.state.isSpeaker) {
  //       const result = e.result;
  //       const transcript = result.privText;
  //       this.setState({
  //         transcriptionResults: transcript
  //       });
  //       // console.log('translation', transcript);
  //       for (const languageObj of this.state.languageData) {
  //         const existingIndex = result.privTranslations.privMap.privKeys.findIndex(
  //           item => item === languageObj.language
  //         );
  //         if (existingIndex != -1) {
  //           let translation = `${result.privTranslations.privMap.privValues[existingIndex]}`;

  //           const transcriptObj = {
  //             end: `${result.privOffset}`,
  //             duration: `${result.privDuration}`,
  //             text: translation,
  //             recognized: false,
  //             name: this.state.userName,
  //             language: languageObj.language
  //           };

  //           //this.generateTranscriptData(transcriptObj)
  //           if (this.rtmClient.connectionState == 'CONNECTED') {
  //             this.sendMsg(JSON.stringify(transcriptObj));
  //           }
  //         }
  //       }
  //     }
  //   };

  //   this.translationRecognizer.recognized = (s, e) => {
  //     // if (e.result.reason) {
  //     const existingIndex = e.result.privTranslations.privMap.privKeys.findIndex(item => item === 'en');
  //     if (existingIndex != -1) {
  //       if (this.state.isSpeaker) {
  //         const result = e.result;
  //         let translation = `${result.privTranslations.privMap.privValues[existingIndex]}`;
  //         const currentUTCTimestampString = moment.utc().format('YYYY-MM-DD HH:mm:ss');
  //         let sendMsgData = {
  //           end: '' + currentUTCTimestampString,
  //           duration: `${result.privDuration}`,
  //           text: translation,
  //           recognized: true,
  //           language: 'en',
  //           name: this.state.userName
  //         };
  //         if (this.startInterviewData !== null || this.state.isRecordingStart == 1) {
  //           // this.generateTranscriptData(sendMsgData)
  //           if (this.rtmClient.connectionState == 'CONNECTED') {
  //             this.sendMsg(JSON.stringify(sendMsgData));
  //           }
  //           this.setState({
  //             transcriptData: [...this.state.transcriptData, sendMsgData]
  //           });

  //           this.props.sendTranscriptData(this.state.transcriptData);
  //         }
  //         // dispatch(sendTranscriptData(this.state.transcriptData))
  //       }
  //     }
  //   };

  //   this.translationRecognizer.canceled = (s, e) => {
  //     console.log.log('IN AND OUT', 'Azure| Recognition Cancel', 202, 'Recognition session canceled ' + e);
  //     this.sendToMixPanel('Azure| Recognition Cancel', 202, 'Recognition session canceled ' + e);
  //     setTimeout(() => {
  //       if (!this.state.translationStop) {
  //         this.stopTranslationRecognition();
  //         this.startTranslation(e);
  //       }
  //     }, 5000);
  //   };

  //   this.translationRecognizer.sessionStopped = (s, e) => {
  //     this.sendToMixPanel('Azure | Recognition Stop', 203, 'Recognition session stopped.');
  //   };

  //   this.translationRecognizer.startContinuousRecognitionAsync(
  //     e => {
  //       console.log('IN AND OUT Azure | Recognition Start', 204, 'Recognition session started.' + reason);
  //       this.sendToMixPanel('Azure | Recognition Start', 204, 'Recognition session started.' + reason);
  //     },
  //     err => {
  //       console.log(`ERRORss: ${err}`);
  //     }
  //   );
  // };

  // helper to force-stop and dispose the current recognizer (returns a Promise)
  _stopAndDisposeRecognizer = instanceId => {
    return new Promise((resolve, reject) => {
      if (!this.translationRecognizer) {
        console.log(`[${instanceId}] no existing recognizer to stop`);
        return resolve();
      }

      console.log(`[${instanceId}] stopping existing recognizer...`);
      let finished = false;

      const forceClose = why => {
        if (finished) return;
        finished = true;
        try {
          this.translationRecognizer.close();
        } catch (err) {
          console.warn(`[${instanceId}] force close threw:`, err);
        }
        this.translationRecognizer = null;
        console.warn(`[${instanceId}] forced close (${why}) and cleared recognizer`);
        resolve();
      };

      // safety timeout: if stop callback never fires, force close after 2s
      const timeout = setTimeout(() => forceClose('timeout'), 2000);

      try {
        this.translationRecognizer.stopContinuousRecognitionAsync(
          () => {
            clearTimeout(timeout);
            try {
              if (this.translationRecognizer) {
                this.translationRecognizer.close();
                this.translationRecognizer = null;
              }
            } catch (err) {
              console.warn(`[${instanceId}] close after stop threw:`, err);
            }
            finished = true;
            console.log(`[${instanceId}] stop callback fired and closed`);
            resolve();
          },
          err => {
            clearTimeout(timeout);
            console.warn(`[${instanceId}] stop error callback:`, err);
            forceClose('stop-error-callback', err);
          }
        );
      } catch (err) {
        clearTimeout(timeout);
        console.warn(`[${instanceId}] stop threw synchronously:`, err);
        forceClose('stop-threw', err);
      }
    });
  };

  // main function - async so we can await the stop/dispose
  getTranslationRecognizer = async (sourceLang, reason) => {
    
    if (!(this.state.isRecordingStart == 1 || this.startInterviewData != null)){
      return;
    }

    // if (BASE_TIMESTAMP == null && (this.state.isRecordingStart == 1 || this.startInterviewData != null)) {
    //   BASE_TIMESTAMP = moment.utc();
    // }
    
    const instanceId = Date.now(); // unique id for logs
    console.log(`[${instanceId}] getTranslationRecognizer start — reason:`, reason);

    // prevent concurrent restarts
    if (this._isRestartingRecognizer) {
      console.log(`[${instanceId}] restart already in progress, skipping`);
      return;
    }

    // Initialize restart flag
    this._isRestartingRecognizer = true;

    // Ensure cleanup on error
    const cleanup = () => {
      this._isRestartingRecognizer = false;
      if (this.translationRecognizer) {
        try {
          this.translationRecognizer.close();
        } catch (err) {
          console.warn('Cleanup error:', err);
        }
        this.translationRecognizer = null;
      }
    };

    try {
      // 1) stop & dispose existing recognizer (wait for it, with safety fallback)
      await this._stopAndDisposeRecognizer(instanceId);

      // 2) CRITICAL: Wait longer for microphone to be fully released by Agora SDK
      // The error occurs when Microsoft SDK tries to access mic while Agora is still using it
      await new Promise(r => setTimeout(r, 1000)); // Increased from 300ms to 1000ms

      // 3) Verify Agora audio track is ready and enabled before accessing microphone
      if (!this.localTracks.audioTrack) {
        this._isRestartingRecognizer = false;
        return;
      }

      // 4) Additional delay to ensure microphone is fully available
      await new Promise(r => setTimeout(r, 500));

      // 5) create audio & speech configs with error handling
      let audioConfig;
      let speechTranslationConfig;
      
      try {
        if (BASE_TIMESTAMP == null) {
          BASE_TIMESTAMP = moment.utc();
        }
        audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
        speechTranslationConfig = sdk.SpeechTranslationConfig.fromSubscription(SPEECH_KEY, SPEECH_REGION);
      } catch (error) {
        this._isRestartingRecognizer = false;
        return;
      }

      // prefer full locale codes, e.g. "en-US" not "en"
      speechTranslationConfig.speechRecognitionLanguage = sourceLang || 'en-US';
      // optional: try without dictation to test partials
      // speechTranslationConfig.enableDictation(); // comment out for diagnostics

      for (const languageObj of this.state.languageData) {
        if (languageObj.language && languageObj.language !== '') {
          speechTranslationConfig.addTargetLanguage(languageObj.language);
        }
      }
      if (!this.state.languageData.some(item => item.language === 'en')) {
        speechTranslationConfig.addTargetLanguage('en');
      }

      // 6) create fresh recognizer with error handling
      let recognizer;
      try {
        recognizer = new sdk.TranslationRecognizer(speechTranslationConfig, audioConfig);
        recognizer._instanceId = instanceId;
        this.translationRecognizer = recognizer;
      } catch (error) {
        this.sendToMixPanel('Speech Recognizer Creation Failed', 500, `Failed to create recognizer: ${error}`);
        this._isRestartingRecognizer = false;
        // Clean up audio config if recognizer creation fails
        try {
          audioConfig.close();
        } catch (closeError) {
          console.warn(`[${instanceId}] Error closing audio config:`, closeError);
        }
        return;
      }

      // 5) attach full set of event handlers with robust logging
      recognizer.sessionStarted = (s, e) => {
        console.log(`[${instanceId}] sessionStarted`, e);
      };
      recognizer.sessionStopped = (s, e) => {
        console.log(`[${instanceId}] sessionStopped`, e);
      };
      recognizer.recognizing = (s, e) => {
        // try common fields, fallback to priv* if present
        const text = e?.result?.text ?? e?.result?.privText ?? '';
        console.log(`[${instanceId}] recognizing -> text:`, text, 'raw result:', e.result);
        // your existing handling (send partial translations) — be defensive about priv* fields:
        if (this.state.isSpeaker) {
          try {
            const result = e.result;
            const transcript = result?.privText ?? result?.text ?? '';
            this.setState({ transcriptionResults: transcript });

            // try two possible shapes for translations
            const keys = result?.privTranslations?.privMap?.privKeys ?? Object.keys(result?.translations ?? {});
            const valuesMap = result?.privTranslations?.privMap?.privValues ?? result?.translations ?? {};

            for (const languageObj of this.state.languageData) {
              const lang = languageObj.language;
              if (!lang) continue;
              // handle privMap shape
              if (Array.isArray(keys) && keys.indexOf(lang) !== -1) {
                const idx = keys.indexOf(lang);
                const translation = `${valuesMap[idx]}`;
                // send transcriptObj...
                if (this.rtmClient && this.rtmClient.connectionState === 'CONNECTED') {
                  const transcriptObj = {
                    end: `${result.privOffset ?? result.offset ?? ''}`,
                    duration: `${result.privDuration ?? result.duration ?? ''}`,
                    text: translation,
                    recognized: false,
                    name: this.getLocalCaptionDisplayName(),
                    language: lang
                  };
                  this.sendMsg(JSON.stringify(transcriptObj));
                }
              } else if (result?.translations && result.translations[lang]) {
                // handle translations object
                const translation = result.translations[lang];
                if (this.rtmClient && this.rtmClient.connectionState === 'CONNECTED') {
                  const transcriptObj = {
                    end: `${result.offset ?? ''}`,
                    duration: `${result.duration ?? ''}`,
                    text: translation,
                    recognized: false,
                    name: this.getLocalCaptionDisplayName(),
                    language: lang
                  };
                  this.sendMsg(JSON.stringify(transcriptObj));
                }
              }
            }
          } catch (err) {
            console.warn(`[${instanceId}] recognizing handler error:`, err);
          }
        }
      };

      recognizer.recognized = (s, e) => {
       
      
        try {
          const result = e.result;

          this.sendToMixPanel('RTM | Recognized Result', 201, result);

          const keys =
          result?.privTranslations?.privMap?.privKeys ??
          Object.keys(result?.translations ?? {});
    
          const valuesMap =
            result?.privTranslations?.privMap?.privValues ??
            result?.translations ??
            {};

            const existingIndex = (
              Array.isArray(keys) ? keys : []
            ).findIndex(item => item === 'en');
      
         
          if (e.result.reason === sdk.ResultReason.TranslatedSpeech) {
            console.log("this.state.isSpeaker",this.state.isSpeaker)
            this.sendToMixPanel('RTM | Is Speaker', 201, this.state.isSpeaker);
            if (this.state.isSpeaker) {
               const translation =
                (
                  Array.isArray(valuesMap)
                    ? valuesMap[existingIndex]
                    : result?.translations?.en
                ) ?? '';
      
          
              const offsetTicks =
                result.offset ??
                result.privOffset ??
                0;
      
              const durationTicks =
                result.duration ??
                result.privDuration ??
                0;
      
            
              const offsetMs = offsetTicks / 10000;
              const durationMs = durationTicks / 10000;

              const end = performance.now();
              const elapsedMs = end - start;

              const endTime = BASE_TIMESTAMP.clone().add(elapsedMs, 'milliseconds');
              const startTime = endTime.clone().subtract(durationMs, 'milliseconds');

      
            
              const sendMsgData = {
                start: startTime.format(
                  'YYYY-MM-DD HH:mm:ss.SSS'
                ),
      
                end: endTime.format(
                  'YYYY-MM-DD HH:mm:ss.SSS'
                ),
      
                offset: offsetTicks,
      
                duration: durationTicks,
      
                text: translation,
      
                recognized: true,
      
                language: 'en',
      
                name: this.getLocalCaptionDisplayName()
              };

              this.sendToMixPanel('RTM | Send Msg Data', 201, sendMsgData);
      
              // -----------------------------------
              // RTM Send
              // -----------------------------------
              const canSendToRtm =
                this.startInterviewData !== null ||
                this.state.isRecordingStart == 1;

              this.sendToMixPanel('RTM | Can Send to RTM', 201, canSendToRtm);
              this.sendToMixPanel('RTM | Connection State', 201, this.rtmClient.connectionState);
          

              console.log("cansendToRtm",canSendToRtm,this.startInterviewData,this.state.isRecordingStart )
             
              if (
                canSendToRtm &&
                this.rtmClient &&
                this.rtmClient.connectionState === 'CONNECTED'
              ) {
                this.sendMsg(
                  JSON.stringify(sendMsgData)
                );
              }
      
              // -----------------------------------
              // Local transcript sync
              // -----------------------------------
              const transcriptWithResolvedName = {
                ...sendMsgData,
                name: this.getLocalCaptionDisplayName()
              };
      
              const newTranscriptData = [
                ...this.state.transcriptData,
                transcriptWithResolvedName
              ];
      
              this.setState({
                transcriptData: newTranscriptData
              });

              console.log("New Transcript Data", newTranscriptData);

              this.sendToMixPanel(
                'Final Transcript | Store Message Success',
                201,
                newTranscriptData
              );
      
              this.props.sendTranscriptData(
                newTranscriptData
              );
      
         
            }
          }
          
      
        } catch (err) {
          console.warn(
            `[${instanceId}] recognized handler error:`,
            err
          );
          this.sendToMixPanel('Recognizer | recognized handler error', 500, `Error calling recognized: ${err}`);
        }
      };
     
      recognizer.canceled = (s, e) => {
        console.warn(`[${instanceId}] canceled ->`, e);
        // inspect these two fields carefully
        console.warn(`[${instanceId}] canceled.reason:`, e.reason, 'errorDetails:', e.errorDetails);
        this.sendToMixPanel('Azure| Recognition Cancel', 202, 'Recognition session canceled ' + JSON.stringify(e));
        // optionally attempt restart here (but be careful of restart loops)
      };

      // 7) start and log start result with error handling
      try {
        if (this.localTracks.audioTrack.enabled) {
        recognizer.startContinuousRecognitionAsync(
          () => {
            
          },
          err => {
            this.sendToMixPanel('Speech Recognition Start Failed', 500, `startContinuousRecognitionAsync failed: ${err}`);
            // Clean up on failure to prevent memory leaks
            this._isRestartingRecognizer = false;
            if (this.translationRecognizer) {
              try {
                this.translationRecognizer.close();
              } catch (closeError) {
                console.warn(`[${instanceId}] Error closing recognizer after start failure:`, closeError);
              }
              this.translationRecognizer = null;
            }
          }
        );
        }
      } catch (error) {
        this.sendToMixPanel('Speech Recognition Call Failed', 500, `Error calling startContinuousRecognitionAsync: ${error}`);
        this._isRestartingRecognizer = false;
        if (this.translationRecognizer) {
          try {
            this.translationRecognizer.close();
          } catch (closeError) {
            console.warn(`[${instanceId}] Error closing recognizer:`, closeError);
          }
          this.translationRecognizer = null;
        }
      }
    } finally {
      this._isRestartingRecognizer = false;
    }
  };

  stopTranslationRecognition = async () => {
    if (this.translationRecognizer != null) {
      await this.translationRecognizer?.stopContinuousRecognitionAsync(
        () => {
          // this.translationRecognizer.close()
          console.log('Translation stopped!!');
        },
        e => {
          console.log('Error while stopping translation services!!');
        }
      );
    }
    this.setState({ TranslationLanguage: false });
  };

  sendDataAPi = data => {
    this.props.storeTranscriptLogs(data);
    // dispatch(storeTranscriptLogs(data));
  };

  sendMessageDataAPi = data => {
    this.props.storeTranscriptMessageLogs(data);
    // dispatch(storeTranscriptMessageLogs(data));
  };

  startTranslationCC = () => {
    console.log('TranslationLanguage', this.state.TranslationLanguage);
    if (this.state.TranslationLanguage) {
      this.setState({ startTranslation: false, TranslationLanguage: false });
    } else {
      this.sendTurnOn();

      this.setState({ startTranslation: true, TranslationLanguage: true });
    }
  };

  subscribe = async (user, mediaType) => {
const uid = user.uid;
    if (uid == '240000') {
      this.uidarray['PrimaryResearcher'] = uid;
      // Mark primary researcher as joined
      this.primaryResearcherJoined = true;
      // If there was a timer running, clear it
      if (this.primaryResearcherCheckTimer) {
        clearTimeout(this.primaryResearcherCheckTimer);
        this.primaryResearcherCheckTimer = null;
      }
      // Dismiss any active toast about primary researcher not joining
      if (this.primaryResearcherToastId) {
        toast.dismiss(this.primaryResearcherToastId);
        this.primaryResearcherToastId = null;
      }
      // Close the modal if it's open
      if (this.state.showPrimaryResearcherModal) {
        this.setState({ showPrimaryResearcherModal: false });
      }
    } else if (uid == '1000') {
      this.uidarray['Respondant'] = uid;
    } else if (uid == '1500') {
      this.uidarray['RespondentOnWeb'] = uid;
    } else if (uid == '123456789' || uid == '12345678' || uid == '1234567') {
      // Determine who is screen sharing
      const isResearcherScreenShareB = uid === '123456789';
      const isRespondentScreenShareB = uid === '1234567';
      const isSecondaryResearcherScreenShareB = uid === '12345678';
      // Check if this is the user's own screen share appearing as a remote user
      // For secondary researchers: uid 12345678 when they're currently sharing (stateSharing = true)
      // For primary researchers: uid 123456789 when they're currently sharing
      // For respondents: uid 1234567 when they're currently sharing
      // IMPORTANT: uid can be a number or string, so we need to handle both types
      const uidStr = String(uid);
      const uidNum = Number(uid);
      
      // Check if screenshareId matches (this is the most reliable check)
      const screenshareIdMatches = String(this.screenshareId) === String(uid) || Number(this.screenshareId) === Number(uid);
      
      // Check conditions with type-safe comparisons
      const isSecondaryScreenShareC = (uidStr === '12345678' || uidNum === 12345678);
      const isPrimaryScreenShareC = (uidStr === '123456789' || uidNum === 123456789);
      const isRespondentScreenShareC = (uidStr === '1234567' || uidNum === 1234567);
      const isNotPrimaryOrRespondent = (String(this.uid) !== '240000' && String(this.uid) !== '1500');
      
      const isOwnScreenShare = 
        (isSecondaryScreenShareC && isNotPrimaryOrRespondent && (this.state.stateSharing || screenshareIdMatches)) ||
        (isPrimaryScreenShareC && String(this.uid) === '240000' && (this.state.stateSharing || screenshareIdMatches)) ||
        (isRespondentScreenShareC && String(this.uid) === '1500' && (this.state.stateSharing || screenshareIdMatches));
      
      if (isOwnScreenShare) {
        // Don't subscribe to own screen share - it's already being played locally
        // Just ensure the DOM element exists and is visible
        if (mediaType === 'video') {
          let canvas = document.querySelector('#ag-canvas');
          let dom = document.querySelector('#ag-item-' + uid);
          if (!dom) {
            dom = document.createElement('section2');
            dom.setAttribute('id', 'ag-item-' + uid);
            dom.setAttribute('class', 'ag-item');
            canvas.appendChild(dom);
          }
          // Ensure it's visible with full screen style
          dom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
        }
        return; // Exit early, don't subscribe to own screen share
      }
      
      // Additional safety check: if screenshareId matches and we're a secondary researcher, this is definitely our own
      // Use type-safe comparison
      const screenshareIdMatchesD0 = String(this.screenshareId) === String(uid) || Number(this.screenshareId) === Number(uid);
      const isSecondaryScreenShareD0 = (String(uid) === '12345678' || Number(uid) === 12345678);
      const isDefinitelyOwnScreenShare = isSecondaryScreenShareD0 && screenshareIdMatchesD0 && String(this.uid) !== '240000' && String(this.uid) !== '1500';
      
      if (isDefinitelyOwnScreenShare) {
        return; // Exit early, don't process as remote screen share
      }
      
      // Check if there's already screen sharing and stop it (only if it's a different user's screen share)
      // Use type-safe comparison
      const existingScreenShare = this.uidarray['ScreenShare'];
      const isDifferentScreenShare = existingScreenShare && (String(existingScreenShare) !== String(uid) && Number(existingScreenShare) !== Number(uid));
      if (isDifferentScreenShare) {
        this.stopOtherUserScreenShare();
        // Show notification that previous screen share was stopped
        // if (typeof toast !== 'undefined') {
        //   // toast.info('Previous screen sharing was stopped because another user started screen sharing.');
        // }
      }
      
      // Store the old screen share UID before potentially clearing it
      const oldScreenShareUID = this.uidarray['ScreenShare'];
      
      // Type-safe comparisons
      const screenshareIdMatchesE = String(this.screenshareId) === String(uid) || Number(this.screenshareId) === Number(uid);
      const uidarrayMatches = String(this.uidarray['ScreenShare']) === String(uid) || Number(this.uidarray['ScreenShare']) === Number(uid);
      
      // If current user is screen sharing and another user starts screen sharing, stop current user's screen share
      // But preserve the new screen share UID by passing preserveNewScreenShare=true
      // IMPORTANT: Don't stop if this is the same screen share (own screen share)
      if (this.state.stateSharing && !uidarrayMatches && !screenshareIdMatchesE) {
        // Set the new screen share UID BEFORE calling handleScreenShareEnd
        // This ensures handleScreenShareEndComprehensive knows to preserve it
        this.uidarray['ScreenShare'] = uid;
        
        // Call handleScreenShareEnd with preserveNewScreenShare=true
        // This will stop the current user's screen share but preserve the new one
        this.handleScreenShareEnd(true);
        
        // Show notification that screen sharing was stopped
        // if (typeof toast !== 'undefined') {
        //   // toast.info('Your screen sharing was stopped because another user started screen sharing.');
        // }
      } else {
        this.uidarray['ScreenShare'] = uid;
      }
      
      setTimeout(() => {
        this.forceScreenShareVisibility(uid);
      }, 300);
    }
    // TOASK
    // changed
    // else {
    //   console.log("inside else of subscribe", this.uidarray['other'], uid)
    //   this.uidarray['other'] = uid;
    // }

    try {
      await this.client.subscribe(user, mediaType);
    } catch (error) {
      console.error('error', error);
    }

    if (mediaType === 'video') {
      // this.localTracks.videoTrack = user.videoTrack;
      let canvas = document.querySelector('#ag-canvas');
      //Object.values(this.uidarray).map((value, index) => {
      // const id = value;
      let dom = document.querySelector('#ag-item-' + uid);

      if (!dom) {
        dom = document.createElement('section2');
        dom.setAttribute('id', 'ag-item-' + uid);
        dom.setAttribute('class', 'ag-item');
        dom.setAttribute('value', uid);
        let videoPosition = 'absolute';

        //dom.setAttribute('style', "position:'" + videoPosition + "'");
        // dom.onClick=hello();

        if (localStorage.getItem('user') == 'respondent') {
          // dom.setAttribute('style', 'grid-area: span 12/span 24/13/25');
        }
        canvas.appendChild(dom);

        setTimeout(function() {
          user?.videoTrack?.play('ag-item-' + uid, { fit: 'contain' });
        }, 1000);

        //this.localTracks.videoTrack.play("ag-item-" + uid , {fit: "contain"});
      }
      if (document.querySelector('#ag-item-' + this.uidarray['other'])) {
        let dom = document.querySelector('#ag-item-' + this.uidarray['other']);
        dom.setAttribute('style', `display: none`);
      }

      //screen share by researcher
      if (this.uidarray['ScreenShare']) {
        let dom4 = document.querySelector('#ag-item-' + this.uidarray['ScreenShare']);
        if (dom4 != null)
          if (dom4.getAttribute('id') == 'ag-item-' + this.uidarray['ScreenShare']) {
            // Use !important to ensure screen share stays full screen
            dom4.setAttribute(
              'style',
              `position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;`
            );
            // console.log('Applied full-width style to remote screen share element with !important');
            // console.log('Screen share style after:', dom4.getAttribute('style'));
          }
          //  else {
          //   console.log('===== STEP 7: SCREEN SHARE DOM NOT FOUND =====');
          //   console.log('Screen share DOM not found for UID:', this.uidarray['ScreenShare']);
          // }
        
        // Determine who is screen sharing based on screen share UID
        // '123456789' = researcher, '1234567' = respondent on web, '12345678' = other
        const isResearcherScreenSharing = this.uidarray['ScreenShare'] === '123456789';
        const isRespondentScreenSharing = this.uidarray['ScreenShare'] === '1234567';
        
        // Ensure proper screen share visibility for remote user screen share with delay
        setTimeout(() => {
          this.ensureScreenShareVisibility(this.uidarray['ScreenShare']);
        }, 200);
        
        // Handle screen sharing - show both cameras regardless of who is sharing
        const userType = localStorage.getItem('user');
        if (this.uidarray['ScreenShare']) {
          if (userType == 'respondent') {
            // Check if researcher camera is off
            let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
            const isResearcherCameraOff = !dom6 || !this.uidarray['PrimaryResearcher'];
            
            if (isResearcherCameraOff) {
              // Hide respondent camera completely
              if (this.uidarray['RespondentOnWeb']) {
                let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
                if (dom1) {
                  dom1.setAttribute('style', 'display: none !important;');
                  dom1.removeAttribute('class');
                }
              }
              
              // Ensure screen share is full screen
              if (dom4) {
                dom4.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
              }
            } else {
              // Hide respondent's own camera
              if (this.uidarray['RespondentOnWeb']) {
                let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
                if (dom1) {
                  dom1.setAttribute('style', 'display: none !important;');
                  dom1.removeAttribute('class');
                }
              }
              // Show researcher camera at top-left
              if (dom6) {
                dom6.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                dom6.setAttribute('class', 'researcherBox');
              } else {
                setTimeout(() => {
                  let dom6Retry = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
                  if (dom6Retry) {
                    dom6Retry.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                    dom6Retry.setAttribute('class', 'researcherBox');
                  }
                  this.updateCameraViews();
                }, 500);
              }
            }
          } else if (userType == 'researcher') {
            // Check if current user is a secondary researcher
            const isSecondaryResearcher = this.props.respondantInfo?.isInterviewStart == 0 || (String(this.uid) !== '240000' && String(this.uid) !== '1500');
            
            // On secondary researcher's end: whenever ANY screen share is active, show primary researcher's camera in small box
            if (isSecondaryResearcher) {
              // Secondary researcher view - show primary researcher's camera in small box for any screen share
              if (dom4) {
                dom4.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
              }
              
              // Show primary researcher camera at top-left
              if (this.uidarray['PrimaryResearcher']) {
                let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
                if (dom6) {
                  dom6.removeAttribute('style');
                  dom6.removeAttribute('class');
                  dom6.setAttribute('class', 'researcherBox');
                  dom6.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                }
              }
              
              // Hide respondent camera completely
              let activeRespondentDom = null;
              if (this.uidarray['Respondant']) {
                activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
              } else if (this.uidarray['RespondentOnWeb']) {
                activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
              }
              if (activeRespondentDom) {
                activeRespondentDom.setAttribute('style', 'display: none !important;');
                activeRespondentDom.removeAttribute('class');
              }
            } else {
              // Primary researcher or respondent is sharing - use original logic
              // Check if respondent camera is off
              let activeRespondentDom = null;
              if (this.uidarray['Respondant']) {
                activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
              } else if (this.uidarray['RespondentOnWeb']) {
                activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
              }
              const isRespondentCameraOff = !activeRespondentDom;
              
              if (isRespondentCameraOff) {
                // Respondent camera is off - show ONLY screen share (full screen)
                // Ensure screen share is full screen
                if (dom4) {
                  dom4.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
                }
                // Hide researcher camera completely
                if (this.uidarray['PrimaryResearcher']) {
                  let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
                  if (dom6) {
                    dom6.setAttribute('style', 'display: none !important;');
                    dom6.removeAttribute('class');
                  }
                }
              } else {
                // Respondent camera is on - show respondent camera at top-left, hide researcher camera
                activeRespondentDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                activeRespondentDom.setAttribute('class', 'respondentBox');
                
                // Hide researcher camera
                if (this.uidarray['PrimaryResearcher']) {
                  let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
                  if (dom6) {
                    dom6.setAttribute('style', 'display: none !important;');
                    dom6.removeAttribute('class');
                  }
                }
              }
            }
          }
          
          // Call updateCameraViews to ensure proper camera layout
          setTimeout(() => {
            this.updateCameraViews();
          }, 300);
        }
        
        if (this.uidarray['Respondant']) {
          let dom1 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
          if (dom1 != null)
            if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['Respondant']) {
              // Set respondent camera to small box at top-left corner during screen share
              dom1.setAttribute('class', 'respondentBox');
              dom1.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            }
          // Also show researcher camera beside top-left if screen sharing is active
          if (localStorage.getItem('user') == 'researcher' && this.uidarray['PrimaryResearcher']) {
            let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
            if (dom6) {
              dom6.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 130px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
              dom6.setAttribute('class', 'researcherBox');
            }
          }
        }
        // Respondent on Web start
        if (this.uidarray['RespondentOnWeb']) {
          let dom5 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
          if (dom5 != null)
            if (dom5.getAttribute('id') == 'ag-item-' + this.uidarray['RespondentOnWeb']) {
              
              // Only handle this if respondent is screen sharing (not researcher)
              if (isRespondentScreenSharing && localStorage.getItem('user') == 'respondent') {
                // For respondent: show both cameras - respondent at top-left, researcher at top-right
                let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
                if (dom1) {
                  dom1.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                  dom1.setAttribute('class', 'respondentBox');
                }
                let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
                if (dom6) {
                  // Show researcher camera beside top-left (right next to respondent camera)
                  dom6.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 130px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                  dom6.setAttribute('class', 'researcherBox');
                }
              }
              if (localStorage.getItem('user') == 'researcher') {
                // For researcher: show both cameras - respondent at top-left, researcher beside it
                let dom5 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
                if (dom5) {
                  // Set respondent camera to small box at top-left corner during screen share
                  dom5.setAttribute('class', 'respondentBox');
                  dom5.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                }
                let dom6 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
                if (dom6) {
                  // Show researcher camera beside top-left (right next to respondent camera)
                  dom6.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 130px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                  dom6.setAttribute('class', 'researcherBox');
                }
              }
            }
        }
        //END
        if (this.uidarray['other']) {
          let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
          if (dom3 != null)
            if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
              let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
              if (dom2 != null) {
                dom2.removeAttribute('class');
              }
              // dom3.setAttribute(
              //   "style",
              //   `grid-area: span 3/span 4/7/5;
              //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
              // );
            }
        }
        // if(this.uidarray["PrimaryResearcher"]){
        // let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        // if (dom2 != null)
        //   if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
        //     console.log('scrrenshre---4');
        //     dom2.setAttribute(
        //       'style',
        //       `grid-area: span 3/span 4/10/5;
        //             z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
        //     );
        //   }
        // }
      } else if (this.uidarray['Respondant']) {
        let dom1 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
        if (dom1 != null)
          if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['Respondant']) {
            console.log('Respondant');
            // added by shweta
            // dom1.setAttribute('style', `grid-area: span 3/span 4/7/5;z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`);
          }

        let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom3 != null)
          if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
            console.log('Respondant1');
            // dom3.setAttribute(
            //   "style",
            //   `grid-area: span 3/span 4/7/5;
            //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            // );
          }

        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null) {
          if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
            console.log('Respondant2');
            dom2.removeAttribute('style');
            //added by shweta
            dom2.setAttribute('class', `researcherBox 5`);
            //its for researcher
            if (localStorage.getItem('user') == 'respondent') {
              // dom2.setAttribute('style', `grid-area: span 12/span 24/13/25;border:2px;`);
              dom2.setAttribute('class', `researcherBox 6`);
            }
          }
        }
      } else if (this.uidarray['RespondentOnWeb']) {
        let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
        if (dom1 != null)
          if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['RespondentOnWeb']) {
            console.log('RespondentOnWeb');
            dom1.setAttribute('style', `grid-area: span 12/span 24/13/25;color:yellow`);

            // if (localStorage.getItem('user') == 'respondent') {
            //   dom1.setAttribute(
            //     'style',
            //     `grid-area: span 3/span 4/4/5;z-index:3;width:calc(100% - 20px);height:calc(100% - 20px)`
            //   );
            // }

            if (localStorage.getItem('user') == 'researcher') {
              // dom1.setAttribute(
              //   'style',
              //   `grid-area: span 3/span 4/4/5;z-index:3;width:calc(100% - 20px);height:calc(100% - 20px)`
              // );
              // let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
              // dom2.setAttribute('style', `grid-area: span 12/span 24/13/25;color:11`);
            }
          }

        let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom3 != null)
          if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
            console.log('RespondentOnWeb1');
            // dom3.setAttribute(
            //   "style",
            //   `grid-area: span 3/span 4/7/5;
            //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            // );
          }

        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null)
          if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
            console.log('RespondentOnWeb2');
            // dom2.setAttribute(
            //   'style',
            //   `grid-area: span 3/span 4/4/5;
            //           z-index:3;width:calc(100% - 20px);height:calc(100% - 20px);2`
            // );
            //its for researcher section 2
            if (localStorage.getItem('user') == 'respondent') {
              dom2.setAttribute('style', `grid-area: span 12/span 24/13/25;border:3px;`);
            }
          }
      } else if (this.uidarray['other']) {
        let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom3 != null)
          if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
            console.log('other---1');
            //dom3.setAttribute("style", `grid-area: span 12/span 24/13/25`);
          }

        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null)
          if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
            console.log('other---2');
            // dom2.setAttribute(
            //   'style',
            //   `grid-area: span 3/span 4/4/5;
            //         z-index:1;width:calc(100% - 20px);height:calc(100% - 20px);color:3;`
            // );
          }
      } else {
        console.log('-------1');
        dom.setAttribute('style', `grid-area: span 12/span 24/13/25;color:grey`);
      }
      
      // Ensure proper camera view layout after all DOM manipulation, especially for screen sharing
      if (this.uidarray['ScreenShare']) {
        setTimeout(() => {
          this.updateCameraViews();
        }, 300);
      } else {
        // Also update camera views even when not screen sharing to ensure proper layout
        setTimeout(() => {
          this.updateCameraViews();
        }, 300);
      }
    }
    if (mediaType === 'audio') {
      console.log('Inside mediaTypeAudio');
      // if(this.localTracks.audioTrack != null){
      console.log('Inside audiotrack mediaTypeAudio');
      // if (!this.uidarray['ScreenShare']) {
      console.log('audio going', user, user.audioTrack);
      user.audioTrack?.play();
      // }
      //}
    }
  };

  componentDidMount() {
    let canvas = document.querySelector('#ag-canvas');

    if (this.translationRecognizer != null) {
      this.translationRecognizer.stopContinuousRecognitionAsync(async () => {
        await this.translationRecognizer.close();
        this.sendToMixPanel('translation stopped!!!', 205, `Stopping due to user refresh or page change.`);
        this.translationRecognizer = null;
      });
    }

    let btnGroup = document.querySelector('.ag-btn-group');
    this.preloadImages();
    // let captionBtn = document.querySelector('ag-caption')
    if (this.state.isMicMuted) {
      this.timerId = setTimeout(() => {
        this.setState({ active: false });
      }, 3000);
    }

    canvas.addEventListener('mousemove', () => {
      if (window._toolbarToggle) {
        clearTimeout(window._toolbarToggle);
      }

      btnGroup.classList.add('active');
      window._toolbarToggle = setTimeout(function() {
        btnGroup.classList.remove('active');
        // captionBtn.classList.remove('active'); // corrected from 'rem'
      }, 2000);
    });
  }

  preloadImages = () => {
    const { networkIconPath } = this.state;
    Object.keys(networkIconPath).forEach(key => {
      const img = new Image();
      img.src = networkIconPath[key];
      //console.log("images", img.src)
    });
  };

  showNetworkQualityToast = () => {
    const { networkQuality } = this.state;

    let message = '';
    let submessage = '';
    let iconPath = '';
    let toastClassName = 'custom-toast-body';
    let closeButton = true;
    let autoClose = 5000;

    // Good network (0, 1, 2) - should not reach here, but handle gracefully
    if (networkQuality?.uplinkNetworkQuality === 0 || networkQuality?.uplinkNetworkQuality === 1 || networkQuality?.uplinkNetworkQuality === 2) {
      this.preloadImages();
      toastClassName += ' transparent-toast-body';
      closeButton = false;
    } else if (networkQuality?.uplinkNetworkQuality >= 3 && networkQuality?.uplinkNetworkQuality <= 5) {
      // Poor network (3, 4, 5) – amber toast (same logic as RN: first vs "still poor")
      this.preloadImages();
      toastClassName += ' poor-connection-toast';
      iconPath = this.state.networkIconPath.yellowbar;
      message = 'Poor connection';
      if (!this.hasShownInitialPoorNetworkToast) {
        submessage = 'Change network or wait while we reconnect';
        this.hasShownInitialPoorNetworkToast = true;
      } else {
        submessage = 'Network is still poor, your call may drop';
      }
      autoClose = 5000; // Auto-close after 5 seconds
    } else if (networkQuality?.uplinkNetworkQuality === 6) {
      // No internet (6)
      this.preloadImages();
      toastClassName += ' no-connection-toast';
      iconPath = this.state.networkIconPath.redbar;
      message = 'No connection';
      submessage = 'Check your network connection';
      autoClose = false; // Don't auto-close - stay visible until connection restored
      closeButton = true;
    } else {
      toastClassName += ' transparent-toast-body';
      closeButton = false;
    }

    if (this.toastId) {
      toast.dismiss(this.toastId);
    }
    this.toastId = toast(
      <div style={{ display: 'flex', alignItems: 'center', justifycontent: 'space-around' }}>
        {iconPath && (
          <img src={iconPath} alt={message} style={{ width: '30px', height: '30px', marginRight: '10px' }} />
        )}

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div style={{ fontWeight: 'bold' }}>{message}</div>
          <div style={{ textAlign: 'left', width: '100%' }}>{submessage}</div>
        </div>
      </div>,

      {
        autoClose: autoClose,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: toastClassName,
        closeButton: closeButton ? true : false
      }
    );
  };
  closeToast = () => {
    // Close the toast
    if (this.toastId) {
      toast.dismiss(this.toastId);
    }
  };

  showPrimaryResearcherNotJoinedToast = () => {
    // Dismiss any existing toast
    if (this.primaryResearcherToastId) {
      toast.dismiss(this.primaryResearcherToastId);
    }
    
    this.primaryResearcherToastId = toast.warning(
      <div>
        {this.getPrimaryResearcherDisplayName()} has not joined the call.
        <br />
        This interview will not be analysed
      </div>,
      {
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        className: 'custom-toast-body',
        closeButton: true
      }
    );
  };

  showPrimaryResearcherStillNotJoinedToast = () => {
    // Dismiss any existing toast
    if (this.primaryResearcherToastId) {
      toast.dismiss(this.primaryResearcherToastId);
      this.primaryResearcherToastId = null;
    }
    
    // Show modal popup instead of toast
    this.setState({ showPrimaryResearcherModal: true });
  };

  handleClosePrimaryResearcherModal = () => {
    this.setState({ showPrimaryResearcherModal: false });
  };

  handleContinueAnyway = () => {
    // Close the modal
    this.setState({ showPrimaryResearcherModal: false });
  };

  handleCancelAndContactSupport = () => {
    // Close the modal
    this.setState({ showPrimaryResearcherModal: false });
    // Leave the call
    this.handleExit();
  };

  componentDidUpdate(prevProps) {
    // rerendering
    // console.log('componentDidUpdate');
    let canvas = document.querySelector('#ag-canvas');

    // console.log('canvas', this.state.displayMode);
    // pip mode (can only use when less than 4 people in channel)
    const currentUplinkQuality = this.state.networkQuality?.uplinkNetworkQuality;
    if (currentUplinkQuality !== this.previousUplinkQuality) {
      this.previousUplinkQuality = currentUplinkQuality;
      
      // Determine network state based on quality value
      const isGood = currentUplinkQuality <= 2; // 0, 1, 2
      const isPoor = currentUplinkQuality >= 3 && currentUplinkQuality <= 5; // 3, 4, 5
      const isNoInternetNow = currentUplinkQuality === 6; // 6
      
      if (isGood) {
        this.poorNetworkStreak = 0;
        this.closeToast();
        return;
      }
      
      if (isNoInternetNow) {
        this.poorNetworkStreak = 0;
        this.showNetworkQualityToast();
        // No auto-close for no internet - stays visible
        if (this.toastTimeoutId) {
          clearTimeout(this.toastTimeoutId);
          this.toastTimeoutId = null;
        }
        return;
      }
      
      if (isPoor) {
        // Poor toast is shown from network-quality after a sustained streak;
        // skip immediate toast on the first quality drop here.
        return;
      }    }
    if (this.state.displayMode === 'pip') {
      let no = this.state.streamList.length;
      if (no > 4) {
        this.setState({ displayMode: 'tile' });
        return;
      }
      this.state.streamList.map((item, index) => {
        let id = item.getId();
        let dom = document.querySelector('#ag-item-' + id);

        if (!dom) {
          dom = document.createElement('section3');
          dom.setAttribute('id', 'ag-item-' + id);
          dom.setAttribute('class', 'ag-item');
          // dom.onClick=hello();
          canvas.appendChild(dom);
          item.play('ag-item-' + id, { fit: 'cover' });
        }

        if (id == '240000') {
          dom.setAttribute(
            'style',
            `grid-area: span 3/span 4/4/25;
                    z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
          );
        } else {
          dom.setAttribute('style', `grid-area: span 12/span 24/13/25;color:green`);
        }
      });
    }
    // tile mode
    else if (this.state.displayMode === 'tile') {
      let no = this.state.streamList.length;
      this.state.streamList.map((item, index) => {
        let id = item.getId();
        let dom = document.querySelector('#ag-item-' + id);
        if (!dom) {
          dom = document.createElement('section4');
          dom.setAttribute('id', 'ag-item-' + id);
          dom.setAttribute('class', 'ag-item');
          canvas.appendChild(dom);
          item.play('ag-item-' + id);
        }
        dom.setAttribute('style', `grid-area: ${tile_canvas[no][index]}`);
        item.player.resize && item.player.resize();
      });
    }
    // screen share mode (tbd)
    else if (this.state.displayMode === 'share') {
      // console.log('Screen Share', 'Test');
    }

    if (
      prevProps.startInterviewLastUpdated !== this.props.startInterviewLastUpdated
    ) {
      this.startInterviewData = this.props.startInterviewResponse;
      toast.info(this.props.startInterviewResponse.responseStatus);
      start = performance.now();
      BASE_TIMESTAMP = moment.utc()
      //Primary Researcher Start - Start recording
      this.startTranslation('Initialized Transcription');
     
      this.sendMsg(
        JSON.stringify({
          type: 'START_TRANSCRIPTION',
          payload: {
            message: 'Initialized Transcription',
            startedBy: this.props.userId ,
            baseTimestamp: BASE_TIMESTAMP.toISOString()
          }
        })
      );

      this.startSendMessage();

      
     
    }

    if(this.state.isRecordingStart == 1 && TIME_SET == false && this.uid !== '240000'){
      this.startTranslation();
      TIME_SET = true;
      
    }
   

    // console.log('Screen Share', 'Test');
  }
  eventHandler = () => {
    this.rtmClient.logout();
    this.rtmChannel.leave();
    this.client.leave();
    this.sendToMixPanel('RTM | Left Channel', 207, `RTM member left the channel`);
  };

  componentWillUnmount() {
    this.sendTurnOff();
    // code to remove rtm client
    // code to remove rtm client
    const stopRtc = async () => {
      this.rtmChannel.removeAllListeners();
      this.rtmClient.removeAllListeners();
      // await this.rtmChannel.leave();
      window.removeEventListener('beforeunload', this.eventHandler);
      await this.rtmClient.logout();
      console.log('RTM client released!!!');
    };
    // rtm client release
    if (this.rtmClient && this.rtmClient != null && this.rtmChannel) {
      stopRtc();
    }
    clearTimeout(this.timerId);
    
    // Clean up primary researcher check timer
    if (this.primaryResearcherCheckTimer) {
      clearTimeout(this.primaryResearcherCheckTimer);
      this.primaryResearcherCheckTimer = null;
    }
    
    // Clean up network quality toast timeout
    if (this.toastTimeoutId) {
      clearTimeout(this.toastTimeoutId);
      this.toastTimeoutId = null;
    }
    
    // Clean up network cooldown timer
    if (this.networkCooldownTimer) {
      clearTimeout(this.networkCooldownTimer);
      this.networkCooldownTimer = null;
    }
    
    // Dismiss any active toast
    if (this.primaryResearcherToastId) {
      toast.dismiss(this.primaryResearcherToastId);
      this.primaryResearcherToastId = null;
    }
    
    // Dismiss network quality toast
    if (this.toastId) {
      toast.dismiss(this.toastId);
      this.toastId = null;
    }
    
    // Dismiss all toast messages
    toast.dismiss();
    
    // Close the modal if it's open
    if (this.state.showPrimaryResearcherModal) {
      this.setState({ showPrimaryResearcherModal: false });
    }
    
    if (this.translationRecognizer != null) {
      this.translationRecognizer.stopContinuousRecognitionAsync(async () => {
        await this.translationRecognizer.close();
        console.log('translation stopped!!!', this.translationRecognizer);
        this.sendToMixPanel('translation stopped!!!', 205, `Stopping due to user refresh or page change.`);
        this.translationRecognizer = null;
        this.setState({ transcriptData: [] });  
        this.setState({ transcriptionResults: '' });
      });
    }

    //this.client && this.client.unpublish();
    this.client &&
      this.client.leave(
        () => {
          console.log('Client succeed to leave.');
        },
        () => {
          console.log('Client failed to leave.');
        }
      );

    //destroying interval
    clearInterval(this.intervalReset);
  }

  RTMConnectionLost = () => {
    setTimeout(() => {
      if (this.state.rtmStop) {
        console.log('RTM stopped!!! Restarting...');
        this.initRtm(this.props.channel);
        this.startTranslation('Called from RTMConnectionLost');
        this.sendTurnOn();
      }
    }, 5000);
  };

  resetTimer = () => {
    this.intervalReset = setInterval(() => {
      if (this.resetCount > 60) {
        this.resetCount = 0;
        this.rtmChannel.removeAllListeners();
        this.rtmClient.removeAllListeners();
        this.initRtm(this.props.channel);
        this.sendToMixPanel('RTM | Restart RTM', 205, `Restarting RTM due to no message exchange in last 1 min`);
      } else {
        if (this.state.isSpeaker) {
          this.resetCount += 10;
        }
      }
    }, 10000);
  };

  initRtm = async channel => {
    try {
      //rtm client initialize

      //create rtm client and channel
      const useClient = createClient(this.props.appId, { enableLogUpload: true });
      // const useClient = createClient(this.props.appId);
      const useChannel = createChannel(channel);

      this.rtmClient = useClient();
      this.rtmChannel = useChannel(this.rtmClient);
      let receiverId = '';

      // RTM client login
      console.log(this.USER_ID, '*******countmember this.USER_ID');
      await this.rtmClient.login({
        uid: this.USER_ID
      });
      // uid: this.state.userid.toString()
      console.log('**********RTM CLIENT LOGGED IN**********');

      // create RTM channel
      
       if (this.rtmClient?.connectionState === 'CONNECTED'){
        await this.rtmChannel.join();
        this.sendToMixPanel('RTM | Join Channel', 206, 'RTM member joined the channel.');
       }
    
      
      // Send presence message when primary researcher joins
      if (this.uid == '240000') {
        // Primary researcher - send presence message with RTC UID
        const sendPresenceMessage = async () => {
          const displayName = this.getLocalCaptionDisplayName();
          const presenceMsg = JSON.stringify({
            type: 'PRESENCE',
            rtcUid: String(this.uid),
            role: 'primaryResearcher',
            userName: displayName
          });
          try {
            if (this.rtmClient?.connectionState === 'CONNECTED' && this.rtmChannel) {
              let message = this.rtmClient.createMessage({ text: presenceMsg, messageType: 'TEXT' });
              await this.rtmChannel.sendMessage(message);
            }
          } catch (error) {
            console.error('Failed to send presence message:', error);
          }
        };
        
        // Send immediately if connected, otherwise wait
        if (this.rtmClient?.connectionState === 'CONNECTED') {
          await sendPresenceMessage();
        } else {
          // Wait for connection and then send
          setTimeout(sendPresenceMessage, 1000);
        }
      }
      
      // For secondary researchers: Request presence from primary researcher when joining
      // This ensures we detect primary researcher even if they joined before us
      if (this.props.respondantInfo?.isInterviewStart === 0) {
        const requestPresence = async () => {
          try {
            const requestMsg = JSON.stringify({
              type: 'REQUEST_PRESENCE',
              requesterUid: String(this.uid),
              requesterRole: 'secondaryResearcher'
            });
            if (this.rtmClient?.connectionState === 'CONNECTED' && this.rtmChannel) {
              let message = this.rtmClient.createMessage({ text: requestMsg, messageType: 'TEXT' });
              await this.rtmChannel.sendMessage(message);
            }
          } catch (error) {
            console.error('Failed to request presence:', error);
          }
        };
        
        // Request presence after a short delay to ensure RTM is ready
        setTimeout(requestPresence, 500);
        setTimeout(requestPresence, 2000); // Retry after 2 seconds
      }
      
      const response = await this.rtmClient.getChannelMemberCount([channel]);
      const memberCount = response[channel];
      this.setState({
        participants: memberCount
      });
      await this.fetchParticipantsData();
      
      // For secondary researchers: Check if primary researcher is already in the channel
      // This check happens immediately when RTM is ready, so presence can be detected early
      if (this.props.respondantInfo?.isInterviewStart === 0) {
        this.checkPrimaryResearcherPresence();
        setTimeout(async () => {
          await this.checkPrimaryResearcherPresence();
        }, 1000);
        setTimeout(async () => {
          await this.checkPrimaryResearcherPresence();
        }, 3000);
      }

      this.rtmChannel.on('MemberCountUpdated', async count => {
        this.setState({
          participants: count
        });
        this.fetchParticipantsData();
        //console.log('count change 2', this.state.ParticipantsData);
      });

      window.addEventListener('beforeunload', this.eventHandler);
      // this.rtmClient.on('ConnectionStateChanged', async (state, reason) => {
      //   console.log('ConnectionStateChanged...', state, reason);
      //   var errorCod = 300
      //   if (state == 'DISCONNECTED') {
      //     errorCod = 302
      //   } else if (state == 'CONNECTING') {
      //     errorCod = 303
      //   } else if (state == 'ABORTED') {
      //     errorCod = 304
      //   } else if (state == 'RECONNECTING') {
      //     errorCod = 301
      //   }
      //   //if(this.rtmClient?.connectionState == 'CONNECTED')
      //   // if(state == 'RECONNECTING'){
      //   //   this.setState({
      //   //     transcriptionResults: "Resuming translation... "
      //   //   });
      //   //   console.log("Resuming translation...")
      //   // }
      //   // // if(state == 'CONNECTED'){
      //   // //   this.startTranslation();
      //   // //   this.sendTurnOn();
      //   // // }
      //   // if (state == 'DISCONNECTED' || state == 'ABORTED') {
      //   //   this.setState({
      //   //     transcriptionResults: "Connection disconnected, retrying... "
      //   //   });
      //   //   console.log("Connection disconnected, retrying...")
      //   //   this.setState({rtmStop: true});
      //   //   this.RTMConnectionLost();
      //   // } else {
      //   //   // this.setState({rtmStop: false});
      //   // }
      //   const currentTimestamp = new Date().getTime();
      //   const responseObj = {
      //     statement: {
      //     timeStamp: currentTimestamp,
      //     Platform: 'web',
      //     role: 'researcher',
      //     channelId: this.props.channel,
      //     name: this.state.userName,
      //     event: 'Agora RTM',
      //     userId: this.state.userid,
      //     RTMUserId: this.USER_ID,
      //     errorCode: errorCod,
      //     reson: `Connection state changed: ${state}, reason: ${reason}`
      //     }
      //   };
      //   this.sendDataAPi(responseObj);
      // });

      console.log('**********RTM CHANNEL JOINED**********');
      this.rtmClient.on('ConnectionStateChanged', async (state, reason) => {
        console.log('RTM Connection State Changed...', state, reason);
        //if(this.rtmClient?.connectionState == 'CONNECTED')
        if (state == 'RECONNECTING') {
          this.setState({ isreconnecting: true });
          this.setState({
            transcriptionResults: 'Please wait. Trying to resume captions...'
          });
          this.transcriptionTimeoutId = setTimeout(() => {
            this.setState({
              transcriptionResults: 'Failed to load. Contact support'
            });
          }, 15000);
          console.log('Connection state is reconnecting then resuming translation...', state);
        }
        if (state == 'CONNECTED') {
          // this.startTranslation();
          // this.sendTurnOn();
          this.setState({
            // transcriptionResults: '',
            isreconnecting: false
          });
          if (this.transcriptionTimeoutId) {
            clearTimeout(this.transcriptionTimeoutId);
            this.transcriptionTimeoutId = null;
          }
          
          // Send presence message when primary researcher RTM connection is established
          // This ensures presence is sent even if RTM wasn't ready on initial join
          if (this.uid == '240000') {
            const sendPresenceMessage = async () => {
              try {
                const displayName = this.getLocalCaptionDisplayName();
                const presenceMsg = JSON.stringify({
                  type: 'PRESENCE',
                  rtcUid: String(this.uid),
                  role: 'primaryResearcher',
                  userName: displayName
                });
                if (this.rtmClient?.connectionState === 'CONNECTED' && this.rtmChannel) {
                  let message = this.rtmClient.createMessage({ text: presenceMsg, messageType: 'TEXT' });
                  await this.rtmChannel.sendMessage(message);
                }
              } catch (error) {
                console.error('Failed to send presence message on RTM connect:', error);
              }
            };
            // Send immediately and also retry after a short delay
            sendPresenceMessage();
            setTimeout(sendPresenceMessage, 1000);
          }
          
          // For secondary researchers: When RTM connects, immediately check for primary researcher
          // This catches cases where primary researcher is already in the call
          if (this.props.respondantInfo?.isInterviewStart === 0 && !this.primaryResearcherJoined && !this.primaryResearcherToastShown) {
            // Wait a moment for any pending presence messages to arrive
            setTimeout(async () => {
              await this.checkPrimaryResearcherPresence();
              // If primary researcher is detected, we won't show the toast
              // If not detected, the main check at 6 seconds will handle it
            }, 500);
          }
        }
        if (state == 'DISCONNECTED' || state == 'ABORTED') {
          this.setState({
            transcriptionResults: 'Failed to load. Contact support'
          });
          console.log('Connection disconnected, retrying...', state);
          this.setState({ rtmStop: true });
          this.RTMConnectionLost();
        } else {
          // this.setState({rtmStop: false});
        }
        var errorCod = 300;
        if (state == 'DISCONNECTED') {
          errorCod = 302;
        } else if (state == 'CONNECTING') {
          errorCod = 303;
        } else if (state == 'ABORTED') {
          errorCod = 304;
        } else if (state == 'RECONNECTING') {
          errorCod = 301;
        }
        this.sendToMixPanel(
          'RTM | Connection State Changed',
          errorCod,
          `Connection state changed: ${state}, reason: ${reason}`
        );
        if (state === 'DISCONNECTED') {
          this.sendToMixPanel('RTM | Left Channel', 207, `RTM member left the channel, reason: ${reason}`);
        }
      });

      this.rtmChannel.on('ChannelMessage', async (msg, uid) => {

        console.log("Recieved the messsage -> ",msg)
        const parsedMsg = JSON.parse(msg.text);



        
        
        // Handle presence request from secondary researchers
        if (parsedMsg.type === 'REQUEST_PRESENCE' && this.uid == '240000') {
          const displayName = this.getLocalCaptionDisplayName();
          const presenceMsg = JSON.stringify({
            type: 'PRESENCE',
            rtcUid: String(this.uid),
            role: 'primaryResearcher',
            userName: displayName
          });
          try {
            if (this.rtmClient?.connectionState === 'CONNECTED' && this.rtmChannel) {
              let message = this.rtmClient.createMessage({ text: presenceMsg, messageType: 'TEXT' });
              await this.rtmChannel.sendMessage(message);
            }
          } catch (error) {
            console.error('Failed to send presence in response:', error);
          }
          return;
        }
        
        // Handle presence messages to detect primary researcher (even if camera/mic are off)
        if (parsedMsg.type === 'PRESENCE' && parsedMsg.rtcUid === '240000') {
          if (parsedMsg.userName) {
            this.cachedPrimaryResearcherName = String(parsedMsg.userName).trim();
          }
          if (this.props.respondantInfo?.isInterviewStart === 0) {
            // Secondary researcher detected primary researcher
            this.primaryResearcherJoined = true;
            // Clear any timer
            if (this.primaryResearcherCheckTimer) {
              clearTimeout(this.primaryResearcherCheckTimer);
              this.primaryResearcherCheckTimer = null;
            }
            // Dismiss any active toast
            if (this.primaryResearcherToastId) {
              toast.dismiss(this.primaryResearcherToastId);
              this.primaryResearcherToastId = null;
            }
            // Reset toast shown flag so it can be shown again if needed
            this.primaryResearcherToastShown = false;
            // Close modal if open
            if (this.state.showPrimaryResearcherModal) {
              this.setState({ showPrimaryResearcherModal: false });
            }
          }
          return;
        }
        
        if (parsedMsg.type === 'START_TRANSCRIPTION') {
          console.log('Transcription start event received from:', uid);
          if(BASE_TIMESTAMP == null){
            BASE_TIMESTAMP = moment.utc(parsedMsg.payload.baseTimestamp);
          }

          start = performance.now();
          
        
          this.setState({ isRecordingStart: 1 });
          
          return;

          // // Start transcription locally
          // this.startTranslation(data.payload.message);
        }

        const captionName = this.resolveIncomingCaptionName(parsedMsg?.name);
        const captionNameMatches = item =>
          item.name === captionName || item.name === parsedMsg.name;

        if (parsedMsg) {
          this.setState({ participantsName: { ...parsedMsg, name: captionName } });
        }

        console.log(`Message received ${parsedMsg} from ${uid}`);
        if (parsedMsg.text == 'Please turn on CC..!!') {
          const lang = parsedMsg.language;
          console.log('LANG: ', lang, parsedMsg);
          this.updateData(captionName, lang);
        } else if (parsedMsg && parsedMsg.text == 'Please turn off CC..!!') {
          const data = this.state.displayData;
          const existingIndex = data.findIndex(captionNameMatches);
          if (existingIndex != -1) {
            data[existingIndex].text = '';
            this.setState({ displayData: data });
          }
        } else {
          if (parsedMsg && parsedMsg.recognized) {
            // this.setState({ participantsName : parsedMsg});
            // console.log("Message received ${parsedMsg} from ${uid} ", this.state.participantsName)
            if (this.resetCount > 8) {
              this.resetCount = 0;
            }
          }
          if (this.state.myLanguage.split('-')[0] == parsedMsg.language) {
            const data = this.state.displayData;

            const existingIndex = data.findIndex(captionNameMatches);
            if (existingIndex != -1) {
              data[existingIndex].text = parsedMsg.text;
            } else {
              data.push({ name: captionName, text: parsedMsg.text });
            }
            this.setState({ displayData: data });
            //this.setState({ participantsName: data });
          }
          if (parsedMsg.recognized) {
            //const parsedMsg = JSON.parse(text);
            let hasKey = parsedMsg.hasOwnProperty('recognized');

            // receive message only for primary user
            if (hasKey && parsedMsg.recognized && this.uid == '240000') {
              const { saveRtmTranscriptData } = this.props;
              const InterviewSchedule_ID = localStorage.getItem('InterviewSchedule_ID');
              const transcriptPayload = {
                user_ID: window.$user,
                emailID: window.$emailId,
                uid: String(this.uid),
                InterviewSchedule_ID: InterviewSchedule_ID,
                transcript_data: { ...parsedMsg, name: captionName },
                channel_name: this.props.channel
              };
              saveRtmTranscriptData(transcriptPayload);
              // dispatch(saveRtmTranscriptData(transcriptPayload))
            }

            // const logData = {
            //   respondentId: this.props.respondantInfo.Respondent_ID,
            //   respondentName: this.props.respondantInfo.RespondentName,
            //   researcherId: this.state.userid,
            //   researcherName: this.state.userName,
            //   channelId: this.props.channel,
            //   reason: "Message is received from respondent!",
            // };
            // console.log("in rtm channel message recxived", logData)
            // this.sendMessageDataAPi(logData);

            const resolvedName = captionName || this.resolveIncomingCaptionName(parsedMsg?.name) || parsedMsg?.name;
            const appendedTranscript = { ...parsedMsg, name: resolvedName };
            const nextTranscriptData = [...this.state.transcriptData, appendedTranscript];
            this.setState({ transcriptData: nextTranscriptData });
            this.props.sendTranscriptData(nextTranscriptData);
            // dispatch(sendTranscriptData(this.state.transcriptData))
          }
        }
      });

      //Listening to user joining the channel event.
      this.rtmChannel.on('MemberJoined', async memberId => {
        console.log('-------------Member joined: ', memberId);
        setTimeout(this.sendTurnOn, 1500);
        
        // For primary researcher: When a new member joins, send presence again
        // This ensures secondary researchers who join later can detect the primary researcher
        if (this.uid == '240000') {
            const clientBaseTimestamp = moment.utc();
            this.sendMsg(
              JSON.stringify({
                type: 'START_TRANSCRIPTION',
                payload: {
                  message: 'Initialized Transcription',
                  startedBy: this.props.userId ,
                  baseTimestamp: clientBaseTimestamp.toISOString()
                }
              })
            );
          

                  
         
          const sendPresenceToNewMember = async () => {
            const displayName = this.getLocalCaptionDisplayName();
            const presenceMsg = JSON.stringify({
              type: 'PRESENCE',
              rtcUid: String(this.uid),
              role: 'primaryResearcher',
              userName: displayName
            });
            try {
              if (this.rtmClient?.connectionState === 'CONNECTED' && this.rtmChannel) {
                let message = this.rtmClient.createMessage({ text: presenceMsg, messageType: 'TEXT' });
                await this.rtmChannel.sendMessage(message);
              }
            } catch (error) {
              console.error('Failed to send presence to new member:', error);
            }
          };
          // Send presence after a short delay to ensure new member's RTM is ready
          setTimeout(sendPresenceToNewMember, 1000);
        }
        if (this.props.respondantInfo?.isInterviewStart === 0) {
          // Request presence again when a new member joins (might be primary researcher)
          // if(BASE_TIMESTAMP == null) {
          //   BASE_TIMESTAMP = moment.utc();
          // }
          
          const requestPresence = async () => {
            try {
              const requestMsg = JSON.stringify({
                type: 'REQUEST_PRESENCE',
                requesterUid: String(this.uid),
                requesterRole: 'secondaryResearcher'
              });
              if (this.rtmClient?.connectionState === 'CONNECTED' && this.rtmChannel) {
                let message = this.rtmClient.createMessage({ text: requestMsg, messageType: 'TEXT' });
                await this.rtmChannel.sendMessage(message);
              }
            } catch (error) {
              console.error('Failed to request presence:', error);
            }
          };
          setTimeout(requestPresence, 500);
          
          // Check participant data immediately and after a short delay
          // The presence message might arrive slightly after MemberJoined event
          this.checkPrimaryResearcherPresence();
          setTimeout(async () => {
            await this.checkPrimaryResearcherPresence();
          }, 500);
          setTimeout(async () => {
            await this.checkPrimaryResearcherPresence();
          }, 2000);
        }
        
        const currentTimestamp = new Date().getTime();
        const responseObj = {
          statment: {
            timeStamp: currentTimestamp,
            Platform: 'web',
            role: 'researcher',
            channelId: this.props.channel,
            name: this.state.userName,
            event: 'Agora RTM',
            userId: this.state.userid,
            RTMUserId: this.USER_ID,
            errorCode: 206,
            reson: `RTM member joined the channel, member id: ${memberId}`
          }
        };
      });

      //Listening to member leaving the channel event
      this.rtmChannel.on('MemberLeft', memberId => {
        console.log('--------------Member left: ', memberId);
        const currentTimestamp = new Date().getTime();
        const responseObj = {
          statement: {
            timeStamp: currentTimestamp,
            Platform: 'web',
            role: 'researcher',
            channelId: this.props.channel,
            name: this.state.userName,
            event: 'Agora RTM',
            userId: this.state.userid,
            RTMUserId: this.USER_ID,
            errorCode: 207,
            reson: `RTM member left the channel, member id: ${memberId}`
          }
        };
      });
    } catch (e) {
      // console.log('In rtm channel message not recieved', logData);
      this.sendToMixPanel('RTM | Join Failed', 208, 'initRtm - RTM not initialized with error ' + e);
    }
  };

  updateData = (name, newTarget) => {
    const data = this.state.languageData;
    const existingIndex = data.findIndex(item => item.name === name);
    if (existingIndex != -1) {
      data[existingIndex].language = newTarget;
    } else {
      data.push({ name, language: newTarget });
    }
    this.setState({ languageData: data }, () => {
      console.log('!!!!!!!!! User changed the Language !!!!!!!!');
      // this.stopTranslationRecognition();
      console.log('!!!!!!!!! User changed the Language RESPONDENT JOIN !!!!!!!!');

      this.startTranslation('User changed the Language');
    });
  };

  sendTurnOn = () => {
    if (this.state.myLanguage && this.state.myLanguage != '') {
      const transcriptObj = {
        text: 'Please turn on CC..!!',
        name: this.getLocalCaptionDisplayName(),
        language: this.state.myLanguage?.split('-')[0]
      };
      this.sendMsg(JSON.stringify(transcriptObj));
    } else {
      const transcriptObj = {
        text: 'Please turn on CC..!!',
        name: this.getLocalCaptionDisplayName(),
        language: 'en'
      };
      this.sendMsg(JSON.stringify(transcriptObj));
    }
  };

  sendTurnOff = () => {
    console.log('Member has left and turned off captions...');
    const transcriptObj = {
      text: 'Please turn off CC..!!',
      name: this.getLocalCaptionDisplayName(),
      language: ''
    };
    this.sendMsg(JSON.stringify(transcriptObj));
  };

  handleCamera = async e => {
    console.log('CAMERA', e);
    if (!this.localTracks.videoTrack) {
      if (this.state.cameraPermissionDenied) {
        toast.error('Camera permission denied. Please allow camera access in your browser settings.');
      }
      return;
    }
    
    this.localTracks.videoTrack.enabled
      ? e.currentTarget.classList.add('off')
      : e.currentTarget.classList.remove('off');
    if (this.localTracks.videoTrack.enabled) {
      this.sendToMixPanel('RTC | Video off', 201, 'User video turned off.');
    } else {
      this.sendToMixPanel('RTC | Video on', 201, 'User video turned on.');
    }

    await this.localTracks.videoTrack.setEnabled(!this.localTracks.videoTrack.enabled);
    // e.currentTarget.classList.toggle('off');

    // if (!this.localTrackState.videoTrackMuted) {
    //   this.muteVideo();
    // } else {
    //   this.unmuteVideo();
    // }
  };
  sendToMixPanel = (eventName, errCode, reason) => {
    const currentTimestamp = new Date().getTime();
    const responseObj = {
      statement: {
        timeStamp: currentTimestamp,
        Platform: 'web',
        role: 'researcher',
        channelId: this.props.channel,
        name: this.state.userName,
        event: eventName,
        userId: this.state.userid,
        RTMUserId: this.USER_ID,
        errorCode: errCode,
        reson: reason
      }
    };

    mixPanel.track(responseObj.statement.event, { ...responseObj.statement, memberId: this.uid });
  };

  handleMic = async e => {
    if (!this.localTracks.audioTrack) {
      toast.error('Microphone permission denied. Please allow microphone access in your browser settings.');
      return;
    }
    this.localTracks.audioTrack.enabled
      ? e.currentTarget.classList.add('off')
      : e.currentTarget.classList.remove('off');
    if (this.localTracks.audioTrack.enabled) {
      this.sendToMixPanel('RTC | Mute Mic', 201, 'User mic turned off.');
    } else {
      this.sendToMixPanel('RTC | Unmute Mic', 201, 'User mic turned on.');
    }
    // await this.localTracks.audioTrack.setEnabled(!this.localTracks.audioTrack.enabled)
    // this.setState({ isMicMuted: this.localTracks.audioTrack.enabled, active: this.localTracks.audioTrack, isSpeaker: this.localTracks.audioTrack.enabled });
    // e.currentTarget.classList.toggle('off');
    this.unmuteAudio();
    if (!this.state.isMicMuted) {
      this.setState({ isMicMuted: true, active: true });
      if (this.translationRecognizer != null){
      this.translationRecognizer.stopContinuousRecognitionAsync(async() => {
        this.sendToMixPanel('translation stopped!!!', 205, `Stopping due to mic muted`);
      } );
      }

      this.timerId = setTimeout(() => {
        this.setState({ active: false });
      }, 3000);
    } else {
      this.setState({ isMicMuted: false });
      this.unmuteAudio();
      if (this.translationRecognizer != null){
        this.translationRecognizer.startContinuousRecognitionAsync();
      }
    }
    window.$mic = e.currentTarget.classList[2];
    if (!this.localTrackState.audioTrackMuted) {
      this.muteAudio();
    } else {
      this.unmuteAudio();
    }
    this.setState({ isSpeaker: !this.state.isSpeaker });
  };

  muteAudio = async () => {
    console.log('muteVideo muteAudio***********', this.localTracks.audioTrack.enabled);
    if (!this.localTracks.audioTrack) return;
    /**
     * After calling setMuted to mute an audio or video track, the SDK stops sending the audio or video stream. Users whose tracks are muted are not counted as users sending streams.
     * Calling setEnabled to disable a track, the SDK stops audio or video capture
     */
    await this.localTracks.audioTrack.setEnabled(false);
    this.localTrackState.audioTrackMuted = true;
    // this.setState({ startTranslation: false, TranslationLanguage: false });
    $('#mute-audio').text('Unmute Audio');
  };
  muteVideo = async () => {
    console.log('muteVideo***********', this.localTracks.videoTrack.enabled);
    if (!this.localTracks.videoTrack) return;
    await this.localTracks.videoTrack.setEnabled(false);
    this.localTrackState.videoTrackMuted = true;
    $('#mute-video').text('Unmute Video');
  };
  unmuteAudio = async () => {
    console.log('muteVideo unmuteAudio***********', this.localTracks.audioTrack.enabled);

    if (!this.localTracks.audioTrack) return;
    await this.localTracks.audioTrack.setEnabled(true);
    this.localTrackState.audioTrackMuted = false;
    // this.setState({ startTranslation: true, TranslationLanguage: true });
    $('#mute-audio').text('Mute Audio');
  };
  unmuteVideo = async () => {
    console.log('muteVideo unmuteVideo***********', this.localTracks.videoTrack.enabled);
    if (!this.localTracks.videoTrack) return;
    await this.localTracks.videoTrack.setEnabled(true);
    this.localTrackState.videoTrackMuted = false;
    $('#mute-video').text('Mute Video');
  };

  switchDisplay = e => {
    if (e.currentTarget.classList.contains('disabled') || this.state.streamList.length <= 1) {
      return;
    }
    if (this.state.displayMode === 'pip') {
      this.setState({ displayMode: 'tile' });
    } else if (this.state.displayMode === 'tile') {
      this.setState({ displayMode: 'pip' });
    } else if (this.state.displayMode === 'share') {
      // do nothing or alert, tbd
    } else {
      console.error('Display Mode can only be tile/pip/share');
    }
  };

  hideRemote = e => {
    if (e.currentTarget.classList.contains('disabled') || this.state.streamList.length <= 1) {
      return;
    }
    let list;
    let id = this.state.streamList[this.state.streamList.length - 1].getId();
    list = Array.from(document.querySelectorAll(`.ag-item:not(#ag-item-${id})`));
    list.map(item => {
      if (item.style.display !== 'none') {
        item.style.display = 'none';
      } else {
        item.style.display = 'block';
      }
    });
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  // handleConfirmExit = async () => {
  //   this.setState({ showModal: false });
  //   await this.handleExit();
  // };

  handleExit = async e => {
    const { project_ID } = this.props;
    const id = parseInt(project_ID, 10);
    const payload = {
      channelName: this.props.channel,
      user_ID: this.state.userid
    };
    this.props.SendParticpantsListOnEnd(payload);
    // dispatch(SendParticpantsListOnEnd(payload))

    var lastCall = false;
    this.sendToMixPanel('RTM | Left Channel', 207, `RTM member left the channel`);
    // Dismiss all toast messages when call ends
    toast.dismiss();
    // stop showing message on ui for the member left
    this.sendTurnOff();
    //disable translation
    if (this.translationRecognizer != null) {
      this.translationRecognizer?.stopContinuousRecognitionAsync(() => {
        this.translationRecognizer.close();
        this.sendToMixPanel('translation stopped!!!', 205, `Stopping due to call Exit`);
      });
    }

    // code to remove rtm client
    const stopRtc = async () => {
      this.rtmChannel.removeAllListeners();
      this.rtmClient.removeAllListeners();
      // await this.rtmChannel.leave();
      await this.rtmClient.logout();
    };
    // rtm client release
    if (this.rtmClient) {
      stopRtc();
    }

    console.log('RTC client released!!!');

    this.props.setCallOn(2);
    this.props.setRespondantActive(false);

    if (e && e.currentTarget && e.currentTarget.classList.contains('disabled')) {
      return;
    }
    var trackName = '';
    try {
      var localTracks = this.localTracks;
      for (trackName in localTracks) {
        var track = localTracks[trackName];
        if (track) {
          track.stop();
          track.close();
          localTracks[trackName] = undefined;
        }
      }
      //this.client && this.client.unpublish();
      // if (this.state.stateSharing) {
      //   this.shareClient && this.shareClient.unpublish(this.shareStream);
      //   this.shareStream && this.shareStream.close();
      // }
      (await this.client) &&
        this.client.leave(
          () => {
            console.log('Client succeed to leave.');
          },
          () => {
            console.log('Client failed to leave.');
          }
        );
    } finally {
      this.setState({ readyState: false });
      this.client = null;
      const currentUid = localStorage.getItem('UID');
      // redirect to index
      if (this.uid == '1500') {
        this.props.navigate(`/project/${id}/pre-call-resp`);
      } else {
        if (currentUid == '240000') {
          if (fieldData.InterviewComplete + 1 == resumeData.respondentCount) {
            lastCall = true;
          }
        }

        // this.props.navigate(`/project/${id}/pre-call`);
      }
    }
    const data = {
      cname: this.props.channel,
      uid: String(this.state.uid),
      // uid: '3613483512',
      clientRequest: {}
    };

    const customerKey = process.env.REACT_APP_AGORA_CUSTOMERKEY;
    // Customer secret
    const customerSecret = process.env.REACT_APP_AGORA_CUSTOMERSECRET;
    // Concatenate customer key and customer secret and use base64 to encode the concatenated string
    const plainCredential = customerKey + ':' + customerSecret;
    // Encode with base64
    const encodedCredential = Buffer.from(plainCredential).toString('base64');
    const authorizationField = 'Basic ' + encodedCredential;

    const email = window.$emailId;
    const userid = window.$user; //global variable

    const payload3 = {
      user_ID: userid,
      emailID: email
    };

    const { removeVideoCall } = this.props;
    removeVideoCall(payload3);
    // dispatch(removeVideoCall(payload3));

    const { StopVideoRecording } = this.props;

    //Endinterview code//

    const endInterview = data => {
      return new Promise(function request(resolve) {
        maverickPortalhttp
          .makeRequest(
            maverickPortalApiEndPoint.endInterview.url,
            maverickPortalApiEndPoint.endInterview.methodType,
            data
          )
          .then(response => {
            const res = response.data;
            resolve({ res });
          });
      });
    };

    //END//
    BASE_TIMESTAMP = null;
    if (this.uid == '240000') {
      // StopVideoRecording(data, authorizationField);
      var today = new Date();
      

      var time =
        today.getFullYear().toString() +
        '-' +
        (today.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        today
          .getDate()
          .toString()
          .padStart(2, '0') +
        ' ' +
        today
          .getHours()
          .toString()
          .padStart(2, '0') +
        ':' +
        today
          .getMinutes()
          .toString()
          .padStart(2, '0') +
        ':' +
        today
          .getSeconds()
          .toString()
          .padStart(2, '0');
      const endinterviewdata = {
        user_ID: localStorage.userId,
        projectRepondentVideo_ID: localStorage.projectRepondentVideo_ID,
        // videoName: response.data.serverResponse.fileList[0].fileName,
        // videoName: 'video/' + window.$sid + '_' + localStorage.getItem('channel') + '_' + '0' + '.mp4',
        videoName: null,
        endTime: time,
        sid: window.$sid,
        channelName: this.props.channel,
        //uid: String(this.uid), // can't use same UID as a user, this affects audio in recording. This UID is cloud recording
        uid: '3613483512',
        clientRequest: {}
      };
      endInterview(endinterviewdata);
    }
  };

  handleExitClick = e => {
    const { uid } = this.state;
   
    // const timeValidation = validateTimeline(this.state.transcriptData)
    // console.log("Time Validation: ",timeValidation)
    if (uid === 240000) {
      this.handleOpenModal();
    } else {
      this.handleExit(e);
    }
  };

  handleScreenShareEnd = (preserveNewScreenShare = false) => {
    
    const storeuid = '1500';
    const customerKey = process.env.REACT_APP_AGORA_CUSTOMERKEY;
    // Customer secret
    const customerSecret = process.env.REACT_APP_AGORA_CUSTOMERSECRET;
    // Concatenate customer key and customer secret and use base64 to encode the concatenated string
    const plainCredential = customerKey + ':' + customerSecret;
    // Encode with base64
    const encodedCredential = Buffer.from(plainCredential).toString('base64');
    const authorizationField = 'Basic ' + encodedCredential;
   
    this.localTracks.screenVideoTrack && this.localTracks.screenVideoTrack.close();
  
    this.localTracks.screenAudioTrack && this.localTracks.screenAudioTrack.close();
    // this.localTracks.audioTrack && this.localTracks.audioTrack.close();
    this.shareClient.leave();
    this.sendToMixPanel('RTC | Screen sharing ended', 201, 'User stopped screen share.');
    this.state.stateSharing = false;
    // Use comprehensive screen share end handling
    // Pass preserveNewScreenShare flag to prevent deleting the new screen share
    this.handleScreenShareEndComprehensive(preserveNewScreenShare);
    // const data1 = {
    //   cname: this.props.channel,
    //   uid: '3613483512',
    //   clientRequest: {
    //     streamSubscribe: {
    //       audioUidList: {
    //         subscribeAudioUids: ['#allstream#']
    //       },
    //       videoUidList: {
    //         subscribeVideoUids: [storeuid]
    //       }
    //     }
    //   }
    // };
    // const { VideoRecordingUpdate } = this.props;
    // VideoRecordingUpdate(data1, authorizationField);

    //Update video recording start
    // const resource = {
    //   cname: this.props.channel,
    //   uid: '3613483512',
    //   clientRequest: {
    //     mixedVideoLayout: 3,
    //     // "backgroundColor": "#FF0000",
    //     layoutConfig: [
    //       {
    //         uid: `${this.uidarray.RespondentOnWeb}` == '1500' ? '1500' : '1000',
    //         x_axis: 0.0,
    //         y_axis: 0.0,
    //         width: 1.0,
    //         height: 1.0,
    //         alpha: 1.0,
    //         render_mode: 1
    //       }
    //     ]
    //   }
    // };
    // const { UpdateLayoutVideoRecording } = this.props;
    // UpdateLayoutVideoRecording(resource, authorizationField);
    //END
  };

  restoreCameraViews = () => {
    console.log('restoreCameraViews called - restoring all camera views to visible state');
    
    // Restore researcher camera
    const researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
    if (researcherDom) {
      researcherDom.removeAttribute('style');
      researcherDom.removeAttribute('class');
      console.log('Restored researcher camera visibility');
    }
    
    // Restore respondent camera (Respondant)
    const respondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
    if (respondentDom) {
      respondentDom.removeAttribute('style');
      respondentDom.removeAttribute('class');
      console.log('Restored respondent camera visibility');
    }
    
    // Restore respondent on web camera (RespondentOnWeb)
    const respondentOnWebDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
    if (respondentOnWebDom) {
      respondentOnWebDom.removeAttribute('style');
      respondentOnWebDom.removeAttribute('class');
    }
    
    // Hide any screen share elements
    const screenShareDom = document.querySelector('#ag-item-' + this.screenshareId);
    if (screenShareDom) {
      screenShareDom.setAttribute('style', 'display: none;');
    }
    
    // Also hide any other screen share elements that might exist
    const allScreenShareElements = document.querySelectorAll('[id*="ag-item-123456"]');
    allScreenShareElements.forEach(element => {
      element.setAttribute('style', 'display: none;');
    });

    // After resetting everything, immediately re-apply the default layout so the respondent view returns
    const userType = localStorage.getItem('user');
    
    // Re-query DOM elements to ensure we have the latest references
    const activeRespondentDom = document.querySelector('#ag-item-' + (this.uidarray['Respondant'] || this.uidarray['RespondentOnWeb'])) || respondentDom || respondentOnWebDom;
    const primaryResearcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']) || researcherDom;

    if (userType === 'researcher') {
      // For researchers (including secondary), show respondent in full screen
      if (activeRespondentDom) {
        // Force display: block !important to override any previous display: none !important
        activeRespondentDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important; display: block !important;');
        activeRespondentDom.removeAttribute('class');
      }
      if (primaryResearcherDom) {
        primaryResearcherDom.setAttribute('class', 'researcherBox');
        primaryResearcherDom.removeAttribute('style');
      }
    } else if (userType === 'respondent') {
      if (primaryResearcherDom) {
        primaryResearcherDom.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
      }
      if (respondentDom || respondentOnWebDom) {
        const respondentView = respondentDom || respondentOnWebDom;
        respondentView.setAttribute('class', 'respondentBox');
        respondentView.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1000; display: block;');
      }
    }
  };

  handleScreenShareEndComprehensive = (preserveNewScreenShare = false) => {
    
    // Store the current screen share UID before potentially deleting it
    const currentScreenShareUID = this.uidarray['ScreenShare'];
    
    // Only remove screen share from uidarray if we're not preserving a new one
    // If preserveNewScreenShare is true, it means a new screen share is being set up
    if (!preserveNewScreenShare) {
      delete this.uidarray['ScreenShare'];
    } 
    
    // Hide all screen share elements - check for all possible screen share UIDs
    // But don't hide the new screen share if preserveNewScreenShare is true
    const screenShareUIDs = ['123456789', '1234567', '12345678'];
    screenShareUIDs.forEach(uid => {
      // Skip hiding if this is the preserved screen share UID
      if (preserveNewScreenShare && uid === currentScreenShareUID) {
        return;
      }
      const screenShareElement = document.querySelector('#ag-item-' + uid);
      if (screenShareElement) {
        screenShareElement.setAttribute('style', 'display: none;');
      } 
    });
    
    // Also check for any elements with partial matches
    const allScreenShareElements = document.querySelectorAll('[id*="ag-item-123456"]');
    allScreenShareElements.forEach(element => {
      // Skip hiding if this is the preserved screen share element
      // Note: element.id doesn't have '#' prefix, it's just the ID
      if (preserveNewScreenShare && element.id === 'ag-item-' + currentScreenShareUID) {
        return;
      }
      element.setAttribute('style', 'display: none;');
    });
    
    // Only restore camera views if we're not preserving a new screen share
    // If we're preserving, the new screen share setup will handle camera views
    if (!preserveNewScreenShare) {
      // Restore all camera views
      this.restoreCameraViews();
      
      // Immediately force respondent camera to be visible for researchers
      const userType = localStorage.getItem('user');
      if (userType === 'researcher') {
        setTimeout(() => {
          const respondentUID = this.uidarray['Respondant'] || this.uidarray['RespondentOnWeb'];
          if (respondentUID) {
            const respondentDom = document.querySelector('#ag-item-' + respondentUID);
            if (respondentDom) {
              // Force respondent camera to be visible in full screen
              respondentDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important; display: block !important;');
              respondentDom.removeAttribute('class');
            }
          }
        }, 50);
      }
      
      // Force update camera views after a short delay
      setTimeout(() => {
        this.updateCameraViews();
      }, 100);
      
      // Additional update after longer delay to ensure proper layout
      setTimeout(() => {
        this.updateCameraViews();
      }, 1000);
    }
  };

  stopOtherUserScreenShare = () => {
    // Find and hide any existing screen share elements from other users
    // Check for all possible screen share UIDs: 123456789, 1234567, 12345678
    const screenShareUIDs = ['123456789', '1234567', '12345678'];
    screenShareUIDs.forEach(uid => {
      const screenShareElement = document.querySelector('#ag-item-' + uid);
      if (screenShareElement) {
        screenShareElement.setAttribute('style', 'display: none;');
      }
    });
    
    // Also check for any elements with partial matches
    const allScreenShareElements = document.querySelectorAll('[id*="ag-item-123456"]');
    allScreenShareElements.forEach(element => {
      element.setAttribute('style', 'display: none;');
    });
    
    // Remove any existing screen share from uidarray
    const existingScreenShare = this.uidarray['ScreenShare'];
    if (existingScreenShare && existingScreenShare !== this.screenshareId) {
      delete this.uidarray['ScreenShare'];
    }
    
    // Restore camera views to handle the transition
    this.restoreCameraViews();
    
    // Update camera views to ensure proper layout
    setTimeout(() => {
      this.updateCameraViews();
    }, 100);
  };

  // Method to ensure proper screen share visibility when switching between users
  ensureScreenShareVisibility = (newScreenShareUID) => {
    // Hide all existing screen share elements first
    const screenShareUIDs = ['123456789', '1234567', '12345678'];
    screenShareUIDs.forEach(uid => {
      const screenShareElement = document.querySelector('#ag-item-' + uid);
      if (screenShareElement && uid !== newScreenShareUID) {
        screenShareElement.setAttribute('style', 'display: none;');
      }
    });
    
    // Show the new screen share element with retry mechanism
    const showNewScreenShare = () => {
      const newScreenShareElement = document.querySelector('#ag-item-' + newScreenShareUID);
      if (newScreenShareElement) {
        newScreenShareElement.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
        return true;
      }
      return false;
    };
    
    // Try to show the element immediately
    if (!showNewScreenShare()) {
      // If element doesn't exist yet, retry after a short delay
      setTimeout(() => {
        if (!showNewScreenShare()) {
          // Final retry after longer delay
          setTimeout(showNewScreenShare, 500);
        }
      }, 100);
    }
    
    // Update camera views to ensure proper layout with longer delay
    setTimeout(() => {
      // Only update camera views if screen share element exists
      const screenShareElement = document.querySelector('#ag-item-' + newScreenShareUID);
      if (screenShareElement) {
        this.updateCameraViews();
      } else {
        // Retry after longer delay if element doesn't exist yet
        setTimeout(() => {
          this.updateCameraViews();
        }, 500);
      }
    }, 200);
  };

  // Method to force screen share visibility when switching between users
  forceScreenShareVisibility = (screenShareUID) => {
    // Determine who is screen sharing
    const isResearcherScreenSharing = screenShareUID === '123456789';
    const isRespondentScreenSharing = screenShareUID === '1234567';
    
    // Hide all other screen share elements
    const screenShareUIDs = ['123456789', '1234567', '12345678'];
    screenShareUIDs.forEach(uid => {
      if (uid !== screenShareUID) {
        const element = document.querySelector('#ag-item-' + uid);
        if (element) {
          element.setAttribute('style', 'display: none;');
        }
      }
    });
    
    // Show the target screen share element
    const targetElement = document.querySelector('#ag-item-' + screenShareUID);
    if (targetElement) {
      targetElement.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
    }
    
    // Handle camera views when screen sharing is active - show only the other user's camera
    const userType = localStorage.getItem('user');
    if (this.uidarray['ScreenShare']) {
      if (userType == 'respondent') {
        // Check if researcher camera is off
        let researcherDom = null;
        if (this.uidarray['PrimaryResearcher']) {
          researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        }
        const isResearcherCameraOff = !researcherDom || !this.uidarray['PrimaryResearcher'];
        
        // Hide respondent's own camera (always hide during screen share)
        if (this.uidarray['RespondentOnWeb']) {
          let respondentDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
          if (respondentDom) {
            respondentDom.setAttribute('style', 'display: none !important;');
            respondentDom.removeAttribute('class');
          }
        }
        
        if (isResearcherCameraOff) {
          // Ensure screen share is full screen
          if (targetElement) {
            targetElement.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
          }
        } else {
          // Show researcher camera at top-left
          if (researcherDom) {
            researcherDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            researcherDom.setAttribute('class', 'researcherBox');
          }
        }
      } else if (userType == 'researcher') {
        // Check if current user is a secondary researcher
        const isSecondaryResearcher = this.props.respondantInfo?.isInterviewStart == 0 || (String(this.uid) !== '240000' && String(this.uid) !== '1500');
        
        // On secondary researcher's end: whenever ANY screen share is active, show primary researcher's camera in small box
        if (isSecondaryResearcher) {
          // Secondary researcher view - show primary researcher's camera in small box for any screen share
          if (targetElement) {
            targetElement.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
          }
          
          // Show primary researcher camera at top-left
          if (this.uidarray['PrimaryResearcher']) {
            let researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
            if (researcherDom) {
              researcherDom.removeAttribute('style');
              researcherDom.removeAttribute('class');
              researcherDom.setAttribute('class', 'researcherBox');
              researcherDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            }
          }
          
          // Hide respondent camera completely
          let activeRespondentDom = null;
          if (this.uidarray['Respondant']) {
            activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
          } else if (this.uidarray['RespondentOnWeb']) {
            activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
          }
          if (activeRespondentDom) {
            activeRespondentDom.setAttribute('style', 'display: none !important;');
            activeRespondentDom.removeAttribute('class');
          }
        } else {
          // Primary researcher or respondent is sharing - use original logic
          // Check if respondent camera is off
          let activeRespondentDom = null;
          if (this.uidarray['Respondant']) {
            activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
          } else if (this.uidarray['RespondentOnWeb']) {
            activeRespondentDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
          }
          const isRespondentCameraOff = !activeRespondentDom;
          
          if (isRespondentCameraOff) {
            // Respondent camera is off - show ONLY screen share (full screen)
            // Ensure screen share is full screen
            if (targetElement) {
              targetElement.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
            }
            // Hide researcher camera completely
            if (this.uidarray['PrimaryResearcher']) {
              let researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
              if (researcherDom) {
                researcherDom.setAttribute('style', 'display: none !important;');
                researcherDom.removeAttribute('class');
              }
            }
          } else {
            // Respondent camera is on - show respondent camera at top-left and hide researcher
            activeRespondentDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            activeRespondentDom.setAttribute('class', 'respondentBox');
            
            // Hide researcher camera
            if (this.uidarray['PrimaryResearcher']) {
              let researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
              if (researcherDom) {
                researcherDom.setAttribute('style', 'display: none !important;');
                researcherDom.removeAttribute('class');
              }
            }
          }
        }
      }
    }
    
    // Update camera views after a delay to ensure proper layout
    setTimeout(() => {
      this.updateCameraViews();
    }, 300);
  };

  // Method to maintain screen share visibility for local users
  maintainLocalScreenShareVisibility = (screenShareUID) => {
    
    const checkAndFix = () => {
      const element = document.querySelector('#ag-item-' + screenShareUID);
      if (element) {
        const currentStyle = element.getAttribute('style');
        // Check if the element has the correct full-width style
        if (!currentStyle.includes('position: absolute') || !currentStyle.includes('width: 100%')) {
          element.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; color: orange;');
        }
      }
    };
    
    // Check immediately
    checkAndFix();
    
    // Check again after 1 second
    setTimeout(checkAndFix, 1000);
    
    // Check again after 3 seconds
    setTimeout(checkAndFix, 3000);
  };

  sharingScreen = async e => {
    
    try {
      const storeuid = '1000';
      let screenTrack;
      const customerKey = process.env.REACT_APP_AGORA_CUSTOMERKEY;
      // Customer secret
      const customerSecret = process.env.REACT_APP_AGORA_CUSTOMERSECRET;
      // Concatenate customer key and customer secret and use base64 to encode the concatenated string
      const plainCredential = customerKey + ':' + customerSecret;
      // Encode with base64
      const encodedCredential = Buffer.from(plainCredential).toString('base64');
      const authorizationField = 'Basic ' + encodedCredential;

      let uid;
      if (this.uid == '240000') {
        uid = '123456789';
      } else if (this.uid == '1500') {
        uid = '1234567';
      } else {
        uid = '12345678';
      }
      
      // Check if screen sharing is already active - if so, stop it and return
      if (this.state.stateSharing) {
        this.handleScreenShareEnd();
        return; // Exit early to prevent starting screen share again
      }
      this.screenshareId = uid;
      this.uidarray['ScreenShare'] = uid;
      // Check if there's screen sharing from other user and stop it
      if (this.uidarray['ScreenShare'] && this.uidarray['ScreenShare'] !== uid) {
        this.stopOtherUserScreenShare();
        // Show notification that other user's screen share was stopped
        // if (typeof toast !== 'undefined') {
        //   // toast.info('Other user\'s screen sharing was stopped to start your screen share.');
        // }
      } 
      
      if (!this.state.stateSharing) {
        let $ = this.props;
        const screenClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
        this.shareClient = screenClient;
        let dynamicUid = new Date().getHours().toString() + new Date().getMinutes() + new Date().getSeconds();
        [uid, screenTrack] = await Promise.all([
          // Join the channel.
          screenClient.join(this.props.appId, this.props.channel, null, Number(uid)),
          // Create tracks to the local microphone and camera.
          // AgoraRTC.createMicrophoneAudioTrack(),
          // this.localTracks.audioTrack,
          AgoraRTC.createScreenVideoTrack(
            {
              encoderConfig: {
                framerate: 15,
                height: 720,
                width: 960
                // height: 480,
                // width: 640
              },
              systemAudio: 'include'
            },
            'auto'
          )
        ])
          .then(values => {
            this.sendToMixPanel('RTC | Screen sharing started ', 201, 'User started screen share.');
            return values;
          })
          .catch(e => {
            this.sendToMixPanel(
              'RTC | Screen sharing error ',
              201,
              `Got error when started screen share. Error - ${e}`
            );
            console.log('values screen sharing error', e); // [3, 1337, "foo"]
            screenClient.leave(this.props.appId, this.props.channel, null, Number(uid));
          });

        this.state.stateSharing = true;

        if (screenTrack && screenTrack instanceof Array) {
          this.localTracks.screenVideoTrack = screenTrack[0];
          this.localTracks.screenAudioTrack = screenTrack[1];
        } else {
          this.localTracks.screenVideoTrack = screenTrack;
        }

        const streamId = String(uid);
        let canvas = document.querySelector('#ag-canvas');
        let dom = document.querySelector('#ag-item-' + this.screenshareId);
        if (!dom) {
          dom = document.createElement('section5');
          dom.setAttribute('id', 'ag-item-' + this.screenshareId);
          dom.setAttribute('class', 'ag-item');
          canvas.appendChild(dom);
          this.localTracks.screenVideoTrack.play('ag-item-' + this.screenshareId, { fit: 'contain' });
        }

        if (this.uidarray['ScreenShare']) {
          let dom4 = document.querySelector('#ag-item-' + this.uidarray['ScreenShare']);

          if (dom4 != null)
            if (dom4.getAttribute('id') == 'ag-item-' + this.uidarray['ScreenShare']) {
              // Apply full-width style for local screen share
              dom4.setAttribute(
                'style',
                `position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; color: orange;`
              );
            }
          
          // Ensure proper screen share visibility after element is created with delay
          setTimeout(() => {
            this.ensureScreenShareVisibility(this.screenshareId);
          }, 200);
          
          // Force screen share visibility for local user with additional delay
          setTimeout(() => {
            this.forceScreenShareVisibility(this.screenshareId);
          }, 500);
          
          // Maintain screen share visibility for local user
          setTimeout(() => {
            this.maintainLocalScreenShareVisibility(this.screenshareId);
          }, 1000);
          
          // if (this.uidarray['Respondant']) {
          //   let dom1 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
          //   if (dom1 != null)
          //     if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['Respondant']) {
          //       console.log('scrrenshre---2');
          //       // dom1.setAttribute(
          //       //   'style',
          //       //   `grid-area: span 3/span 4/4/5;
          //       //       z-index:3;width:calc(100% - 20px);height:calc(100% - 20px);3`
          //       // );
          //       dom1.setAttribute(
          //         'class',
          //         `researcherBox 7`
          //       );
          //       //its for researcher section 2
          //       if (localStorage.getItem('user') == 'respondent') {
          //         dom1.setAttribute('style', `grid-area: span 12/span 24/13/25;border:4px;`);
          //       }
          //     }
          // }
          //RespondentOnWeb whenscreen sharing is going on
          if (this.uidarray['RespondentOnWeb']) {
            let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
            if (dom1 != null)
              if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['RespondentOnWeb']) {
                // Set respondent camera to small box at top-left corner during screen share
                dom1.setAttribute('class', 'respondentBox');
                dom1.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                
                if (localStorage.getItem('user') == 'respondent') {
                  // For respondent: hide their own camera during screen share
                  dom1.setAttribute('style', 'display: none;');
                }
              }
          }
          //END
          if (this.uidarray['other']) {
            let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
            if (dom3 != null)
              if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {

                // dom3.setAttribute(
                //   "style",
                //   `grid-area: span 3/span 4/7/5;
                //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
                // );
              }
          }
          if (this.uidarray['PrimaryResearcher']) {
            let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
            // dom2.setAttribute('style', 'display: none;')

            let dom3 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
            if (dom3 != null) {
              dom2.setAttribute('style', 'visibility: hidden;');
            }

            if (dom2 != null && dom3 != null) {
              // Set respondent camera to small box at top-left corner during screen share
              dom3.setAttribute('class', 'respondentBox');
              dom3.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            } else if (dom2 != null && dom3 == null) {
              dom2.setAttribute('style', 'display: none;');
              if (localStorage.getItem('user') == 'researcher') {
                if (dom3 != null) {
                  dom3.setAttribute('class', `researcherBox 9`);
                }
                console.log('this.uidarray', this.uidarray);
                let hasKey = this.uidarray.hasOwnProperty('RespondentOnWeb');
                if (hasKey) {
                  let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
                  // Set respondent camera to small box at top-left corner during screen share
                  dom1.setAttribute('class', 'respondentBox');
                  dom1.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
                }
              } else {

                //dom2.setAttribute('class', `researcherBox 10`);
                //dom2.removeAttribute('style');
              }
            }
          }
        }

        // const data = {
        //   cname: this.props.channel,
        //   uid: '3613483512',
        //   clientRequest: {
        //     streamSubscribe: {
        //       audioUidList: {
        //         subscribeAudioUids: ['#allstream#']
        //       },
        //       videoUidList: {
        //         subscribeVideoUids: [streamId]
        //       }
        //     }
        //   }
        // };

        // const { VideoRecordingUpdate } = this.props;
        // VideoRecordingUpdate(data, authorizationField);

        //Code for updating recording on screen share
        // if (this.uid == '240000') {
        //   // Update video recording start
        //   const resource = {
        //     cname: this.props.channel,
        //     uid: '3613483512',
        //     clientRequest: {
        //       mixedVideoLayout: 3,
        //       // "backgroundColor": "#FF0000",
        //       layoutConfig: [
        //         {
        //           uid:`${uid}`,
        //           x_axis: 0.0,
        //           y_axis: 0.0,
        //           width: 1.0,
        //           height: 1.0,
        //           alpha: 1.0,
        //           render_mode: 1
        //         }
        //       ]
        //     }
        //   };
        //   const { UpdateLayoutVideoRecording } = this.props;
        //   UpdateLayoutVideoRecording(resource, authorizationField);
        //   // END
        // }
        //END

        // play local video track
        //this.localTracks.screenVideoTrack.play("ag-canvas");
        //bind "track-ended" event, and when screensharing is stopped, there is an alert to notify the end user.
        this.localTracks.screenVideoTrack.on('track-ended', this.handleScreenShareEnd);

        // publish local tracks to channel
        if (this.localTracks.screenAudioTrack == null) {
          // await this.localTracks.audioTrack.setEnabled(false);
          await screenClient.publish([this.localTracks.screenVideoTrack]);
        } else {
          // await this.localTracks.screenAudioTrack.setEnabled(false);
          await screenClient.publish([
            this.localTracks.screenVideoTrack,
            // this.localTracks.audioTrack
            this.localTracks.screenAudioTrack
          ]);
         
        }

      }
    } catch (error) {
      console.error('🔴 [SCREEN SHARE] ERROR STEP: Error in sharingScreen function:', error);
    }
  };

  streamInitSharing = (uid, attendeeMode, videoProfile, config) => {
    const mic = window.$mic;

    let defaultConfig;
    if (mic === 'off') {
      defaultConfig = {
        streamID: uid,
        audio: false,
        video: false,
        screen: true
      };
    } else {
      defaultConfig = {
        streamID: uid,
        audio: true,
        video: false,
        screen: true
      };
    }

    switch (attendeeMode) {
      case 'audio-only':
        defaultConfig.video = false;
        break;
      case 'audience':
        defaultConfig.video = false;
        defaultConfig.audio = false;
        break;
      default:
      case 'video':
        break;
    }

    let stream = AgoraRTC.createStream(merge(defaultConfig, config));
    // const Reso = this.props.screenResolution;
    const shareScreenResolution = window.$shareScreenResolution;
    stream.setScreenProfile(shareScreenResolution.resolution);
    return stream;
  };

  handleUserPublished = (user, mediaType) => {
    
    const customerKey = process.env.REACT_APP_AGORA_CUSTOMERKEY;
    // Customer secret
    const customerSecret = process.env.REACT_APP_AGORA_CUSTOMERSECRET;
    // Concatenate customer key and customer secret and use base64 to encode the concatenated string
    const plainCredential = customerKey + ':' + customerSecret;
    // Encode with base64
    const encodedCredential = Buffer.from(plainCredential).toString('base64');
    const authorizationField = 'Basic ' + encodedCredential;
    const id = user.uid;
    this.remoteUsers[id] = user;
    
    // If secondary researcher detects primary researcher (uid 240000) joining, mark as joined and clear any notifications
    if (this.props.respondantInfo?.isInterviewStart === 0 && id == '240000') {
      this.primaryResearcherJoined = true;
      // Clear any timer
      if (this.primaryResearcherCheckTimer) {
        clearTimeout(this.primaryResearcherCheckTimer);
        this.primaryResearcherCheckTimer = null;
      }
      // Dismiss any active toast
      if (this.primaryResearcherToastId) {
        toast.dismiss(this.primaryResearcherToastId);
        this.primaryResearcherToastId = null;
      }
      // Reset toast shown flag so it can be shown again if needed
      this.primaryResearcherToastShown = false;
      // Close modal if open
      if (this.state.showPrimaryResearcherModal) {
        this.setState({ showPrimaryResearcherModal: false });
      }
    }

    // Check if this is a screen share UID
    const isScreenShareUID = id == '123456789' || id == '12345678' || id == '1234567';
   
    if (this.uid == '240000') {
    
      if (id != '123456789' && id != '12345678' && id != '1234567') {
        this.subscribe(user, mediaType);
      } else if (id == '1234567') {
        this.subscribe(user, mediaType);
      } else if (id == '12345678') {
        this.subscribe(user, mediaType);
      }
    } else if (this.uid == '1500') {
      if (id != '123456789' && id != '12345678' && id != '1234567') {
        this.subscribe(user, mediaType);
      } else if (id == '123456789') {
        this.subscribe(user, mediaType);
      } else if (id == '12345678') {
        this.subscribe(user, mediaType);
      }
    } else if (this.uid == this.uidarray.other) {
      if (id != '12345678' && id != '123456789' && id != '1234567') {
        this.subscribe(user, mediaType);
      } else if (id == '123456789') {
        this.subscribe(user, mediaType);
      } else if (id == '1234567') {
        this.subscribe(user, mediaType);
        // TOASK
      } else if (id == '12345678') {
        //changed added condition
        this.subscribe(user, mediaType);
      }
    } 

    // Handle camera view logic when users join
    setTimeout(() => {
      this.updateCameraViews();
    }, 1000);

    if (this.uid == '240000') {
      //If loop for calling when secondary researcher is there
      if (`${id}` === '123456789' || `${id}` === '12345678' || `${id}` === '1234567') {
        // Update video recording start
        const resource = {
          projectRespondent_ID: this.props.respondantInfo?.projectRespondent_ID,
          cname: this.props.channel,
          //uid: String(this.uid), // can't use same UID as a user, this affects audio in recording. This UID is cloud recording
          uid: '3613483512',
          user_ID: localStorage.userId,
          clientRequest: {
            mixedVideoLayout: 3,
            // "backgroundColor": "#FF0000",
            layoutConfig: [
              {
                uid: `${id}`,
                x_axis: 0.0,
                y_axis: 0.0,
                width: 1.0,
                height: 1.0,
                alpha: 1.0,
                render_mode: 1
              }
            ]
          },
          projectRepondentVideo_ID: this.respondantInfo?.projectRepondentVideo_ID
        };
        const { requestUpdateVideoLayout } = this.props;
        // UpdateLayourequestUpdateVideoLayouttVideoRecording(resource, authorizationField);
        requestUpdateVideoLayout(resource, authorizationField);
        // END
      }
    }
  };

  updateCameraViews = () => {
    const userType = localStorage.getItem('user');
    
    // Check if screen sharing is active
    const isScreenSharing = this.uidarray['ScreenShare'];
    
    if (userType === 'researcher') {
      // Researcher side logic
      let researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
      let respondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
      let respondentOnWebDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
      
      if (isScreenSharing) {
        // Screen sharing is active
        let screenShareDom = document.querySelector('#ag-item-' + this.uidarray['ScreenShare']);
        
        if (screenShareDom) {
          // Check if current user is a secondary researcher
          const isSecondaryResearcher = this.props.respondantInfo?.isInterviewStart == 0 || (String(this.uid) !== '240000' && String(this.uid) !== '1500');
          
          // On secondary researcher's end: whenever ANY screen share is active, show primary researcher's camera in small box
          if (isSecondaryResearcher) {
            // Secondary researcher view - show primary researcher's camera in small box for any screen share
            screenShareDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
            
            // Check if primary researcher camera is available
            if (researcherDom) {
              // Show primary researcher camera at top-left
              researcherDom.removeAttribute('style');
              researcherDom.removeAttribute('class');
              researcherDom.setAttribute('class', 'researcherBox');
              researcherDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            }
            
            // Hide respondent camera completely
            let activeRespondentDom = respondentDom || respondentOnWebDom;
            if (activeRespondentDom) {
              activeRespondentDom.setAttribute('style', 'display: none !important;');
              activeRespondentDom.removeAttribute('class');
            }
          } else {
            // Primary researcher or respondent is sharing - use original logic
            // Check if respondent camera is off
            let activeRespondentDom = respondentDom || respondentOnWebDom;
            const isRespondentCameraOff = !activeRespondentDom;
            
            if (isRespondentCameraOff) {
              // Respondent camera is off - show ONLY screen share (full screen)
              screenShareDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
              
              // Hide researcher camera completely
              if (researcherDom) {
                researcherDom.setAttribute('style', 'display: none !important;');
                researcherDom.removeAttribute('class');
              }
            } else {
              // Respondent camera is on - show screen share full screen with respondent overlay
              screenShareDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
              
              // Show only respondent camera at top-left, hide researcher camera
              if (activeRespondentDom) {
                // Force remove any existing styles and classes first
                activeRespondentDom.removeAttribute('style');
                activeRespondentDom.removeAttribute('class');
                
                // Apply the respondentBox class
                activeRespondentDom.setAttribute('class', 'respondentBox');
                
                // Force apply inline styles to override any conflicting styles - position at top-left corner
                activeRespondentDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
              }
              
              // Hide researcher camera while screen sharing (researcher view)
              if (researcherDom) {
                researcherDom.setAttribute('style', 'display: none !important;');
                researcherDom.removeAttribute('class');
              }
            }
          }
        } else {
          console.log('UPDATE-CAMERA-VIEWS ERROR: Screen share DOM NOT FOUND');
        }
      } else if (researcherDom && (respondentDom || respondentOnWebDom)) {
        // Both researcher and respondent are present
        // On researcher end: Show respondent in full screen, researcher in small box
        let activeRespondentDom = respondentDom || respondentOnWebDom;
        
        // Set respondent to full screen
        activeRespondentDom.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
        
        // Set researcher to small box
        researcherDom.setAttribute('class', 'researcherBox');
        researcherDom.removeAttribute('style'); // Remove any existing inline styles
      } else if (researcherDom && !respondentDom && !respondentOnWebDom) {
        // Try to find respondent DOM by looking for other ag-item elements
        let allAgItems = document.querySelectorAll('.ag-item');
        
        for (let i = 0; i < allAgItems.length; i++) {
          let item = allAgItems[i];
          if (item.id !== '#ag-item-' + this.uidarray['PrimaryResearcher']) {
            // This might be the respondent
            item.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
            researcherDom.setAttribute('class', 'researcherBox');
            researcherDom.removeAttribute('style');
            break;
          }
        }
      } else if (researcherDom && !respondentDom) {
        // Only researcher is present - show researcher in full screen
        // Force remove any existing class and styles first
        researcherDom.removeAttribute('class');
        researcherDom.removeAttribute('style');
        
        // Apply full screen style
        researcherDom.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
      }
    } else if (userType === 'respondent') {
      // Respondent side logic
      let respondentDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
      let researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
      
      if (isScreenSharing) {
        // Screen sharing is active
        let screenShareDom = document.querySelector('#ag-item-' + this.uidarray['ScreenShare']);
        
        if (screenShareDom) {
          // Show screen share in full screen - ensure it's properly positioned
          screenShareDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
          
          // Check if researcher camera is off
          const isResearcherCameraOff = !researcherDom;
          
          if (isResearcherCameraOff) {
            // Hide respondent camera completely when researcher camera is off
            if (respondentDom) {
              respondentDom.setAttribute('style', 'display: none !important;');
              respondentDom.removeAttribute('class');
            }
            
            // Ensure screen share is full screen and properly positioned
            screenShareDom.setAttribute('style', 'position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; z-index: 1 !important;');
            
            // Hide any researcher camera overlay if it somehow exists
            if (researcherDom) {
              researcherDom.setAttribute('style', 'display: none !important;');
            }
          } else {
            // Show only researcher camera at top-left, hide respondent camera
            researcherDom.setAttribute('style', 'position: absolute !important; width: 120px !important; height: 90px !important; top: 10px !important; left: 10px !important; z-index: 1000 !important; border: 2px solid #00B6ED !important; background: #000 !important; border-radius: 6px !important;');
            researcherDom.setAttribute('class', 'researcherBox');
            
            if (respondentDom) {
              respondentDom.setAttribute('style', 'display: none !important;');
              respondentDom.removeAttribute('class');
            }
          }
        }
      } else if (respondentDom && researcherDom) {
        // Both respondent and researcher are present
        // On respondent end: Show researcher in full screen, respondent in small box
        researcherDom.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
        respondentDom.setAttribute('class', 'respondentBox');
      } else if (respondentDom && !researcherDom) {
        // Only respondent is present - show respondent in full screen
        respondentDom.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1;');
        respondentDom.removeAttribute('class');
      }
    }
  };

  handleUserUnpublished = (user, mediaType) => {
    const customerKey = process.env.REACT_APP_AGORA_CUSTOMERKEY;
    // Customer secret
    const customerSecret = process.env.REACT_APP_AGORA_CUSTOMERSECRET;
    // Concatenate customer key and customer secret and use base64 to encode the concatenated string
    const plainCredential = customerKey + ':' + customerSecret;
    // Encode with base64
    const encodedCredential = Buffer.from(plainCredential).toString('base64');
    const authorizationField = 'Basic ' + encodedCredential;
    if (mediaType === 'video') {
      const id = user.uid;
      delete this.remoteUsers[id];
      $(`#ag-item-${id}`).remove();

      if (id == '240000') {
        // Keep PrimaryResearcher in uidarray when camera is off - only remove DOM
        // This allows updateCameraViews to know researcher is still in call
        // PrimaryResearcher will be removed from uidarray in MemberLeft event when researcher actually leaves
      } else if (id == '1000') {
        delete this.uidarray.Respondant;
      } else if (id == '1500') {
        delete this.uidarray.RespondentOnWeb;
      } else if (id == '123456789' || id == '12345678' || id == '1234567') {
        // When screen sharing ends, use comprehensive handling
        // Only delete screen share if this is actually the current screen share being removed
        // If there's a different screen share still active, preserve it
        if (this.uidarray['ScreenShare'] === id) {
          // This is the screen share that's ending, delete it
          this.handleScreenShareEndComprehensive(false);
        } else {
          // Different screen share is ending, keep the current one
        }
      } else {
        delete this.uidarray.other;
      }
      // Update camera views when users leave
      this.updateCameraViews();

      //delete this.uidarray.ScreenShare;

      if (this.uidarray['ScreenShare']) {
        const userType = localStorage.getItem('user');
        const isRespondentView = userType === 'respondent';
        const isResearcherView = userType === 'researcher';
        
        // Check if researcher camera is off by checking DOM element (for respondent view)
        let researcherDom = null;
        if (this.uidarray['PrimaryResearcher']) {
          researcherDom = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        }
        const isResearcherCameraOff = !researcherDom;
        
        // Check if respondent camera is off by checking DOM element (for researcher view)
        let respondentDom = null;
        let respondentOnWebDom = null;
        if (this.uidarray['Respondant']) {
          respondentDom = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
        }
        if (this.uidarray['RespondentOnWeb']) {
          respondentOnWebDom = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
        }
        const activeRespondentDom = respondentDom || respondentOnWebDom;
        const isRespondentCameraOff = !activeRespondentDom;
        
        // Keep screen share full screen if camera is off (don't reset to grid)
        let dom4 = document.querySelector('#ag-item-' + this.uidarray['ScreenShare']);
        if (dom4 != null && dom4.getAttribute('id') == 'ag-item-' + this.uidarray['ScreenShare']) {
          if ((isRespondentView && isResearcherCameraOff) || (isResearcherView && isRespondentCameraOff)) {
            // Camera is off - keep screen share full screen (already set by updateCameraViews)
            // Don't override - updateCameraViews already set it correctly
          } else {
            // Camera is on - use grid layout
            dom4.setAttribute('style', `grid-area: span 12/span 24/13/25;z-index:2;border:1px`);
          }
        }
        
        // Handle Respondant (for researcher view)
        if (this.uidarray['Respondant']) {
          let dom1 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
          if (dom1 != null && dom1.getAttribute('id') == 'ag-item-' + this.uidarray['Respondant']) {
            if (isResearcherView && isRespondentCameraOff) {
              // Respondent camera is off - keep it hidden (already set by updateCameraViews)
              // Don't override - updateCameraViews already hid it
            } else {
              // Respondent camera is on - show in grid layout
              dom1.setAttribute('class', `respondentBox`);
            }
          }
        }
        
        // Handle RespondentOnWeb (for both views)
        if (this.uidarray['RespondentOnWeb']) {
          let dom5 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
          if (dom5 != null && dom5.getAttribute('id') == 'ag-item-' + this.uidarray['RespondentOnWeb']) {
            if ((isRespondentView && isResearcherCameraOff) || (isResearcherView && isRespondentCameraOff)) {
              // Camera is off - keep respondent camera hidden (already set by updateCameraViews)
              // Don't override - updateCameraViews already hid it
            } else {
              // Camera is on - show respondent camera in grid layout
              dom5.setAttribute(
                'style',
                `grid-area: span 3/span 4/4/5;
                    z-index:1;width:calc(100% - 20px);height:calc(100% - 20px);color:5;`
              );
            }
          }
        }
        if (this.uidarray['other']) {
          let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
          if (dom3 != null)
            if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
              // dom3.setAttribute(
              //   "style",
              //   `grid-area: span 3/span 4/7/5;
              //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
              // );
            }
        }
        // else {
        //   let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        //   if (dom2 != null)
        //     if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
        //       console.log('scrrenshre---4');
        //       dom2.setAttribute(
        //         'style',
        //         `grid-area: span 3/span 4/7/5;
        //             z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
        //       );
        //     }
        // }
      } else if (this.uidarray['Respondant']) {
        let dom1 = document.querySelector('#ag-item-' + this.uidarray['Respondant']);
        if (dom1 != null)
          if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['Respondant']) {
            console.log('Respondant');
            dom1.setAttribute('style', `grid-area: span 12/span 24/13/25; color:#000`);
            dom1.removeAttribute('class', 'researcherBox 11');
            dom1.setAttribute('class', 'ag-item');
          }

        let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom3 != null)
          if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
            console.log('Respondant1');
            // dom3.setAttribute(
            //   "style",
            //   `grid-area: span 3/span 4/7/5;
            //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            // );
          }

        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null) {
          if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
            console.log('Respondant2');
            // dom2.setAttribute(
            //   'style',
            //   `grid-area: span 3/span 4/4/5;
            //           z-index:3;width:calc(100% - 20px);height:calc(100% - 20px);5`
            // );
            //its for researcher section 2
            if (localStorage.getItem('user') == 'respondent') {
              // dom2.setAttribute('style', `grid-area: span 12/span 24/13/25;border:4px;`);
              dom2.setAttribute('class', `researcherBox 12`);
            }
            dom2.setAttribute('class', `researcherBox 13`);
          }
        }
      } else if (this.uidarray['RespondentOnWeb']) {
        let dom1 = document.querySelector('#ag-item-' + this.uidarray['RespondentOnWeb']);
        if (dom1 != null)
          if (dom1.getAttribute('id') == 'ag-item-' + this.uidarray['RespondentOnWeb']) {
            console.log('RespondentOnWeb');
            dom1.setAttribute('style', `grid-area: span 12/span 24/13/25;color:#FFF`);
            if (localStorage.getItem('user') == 'respondent') {
              dom1.setAttribute(
                'style',
                `grid-area: span 3/span 4/4/5;z-index:3;width:calc(100% - 20px);height:calc(100% - 20px)`
              );
            }

            if (localStorage.getItem('user') == 'researcher') {
              dom1.setAttribute('style', `grid-area: span 12/span 24/13/25;11`);
            }
          }

        let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom3 != null)
          if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
            // dom3.setAttribute(
            //   "style",
            //   `grid-area: span 3/span 4/7/5;
            //           z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
            // );
          }

        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null)
          if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
            // dom2.setAttribute(
            //   'style',
            //   `grid-area: span 3/span 4/4/5;
            //           z-index:3;width:calc(100% - 20px);height:calc(100% - 20px);6`
            // );
            //its for researcher section 2
            if (localStorage.getItem('user') == 'respondent') {
              dom2.setAttribute('style', `grid-area: span 12/span 24/13/25;border:4px;`);
            }
          }
      } else if (this.uidarray['other']) {
        let dom3 = document.querySelector('#ag-item-' + this.uidarray['other']);
        if (dom3 != null)
          if (dom3.getAttribute('id') == 'ag-item-' + this.uidarray['other']) {
            console.log('other---1');
            //dom3.setAttribute("style", `grid-area: span 12/span 24/13/25`);
          }

        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null)
          if (dom2.getAttribute('id') == 'ag-item-' + this.uidarray['PrimaryResearcher']) {
            dom2.setAttribute(
              'style',
              `grid-area: span 3/span 4/4/2;
              z-index:1;
              width:calc(100% - 12px);height:calc(100% - 20px);margin-top: 45px;color:6;`
            );
            dom2.removeAttribute('class');
          }
      } else if (this.uidarray['PrimaryResearcher']) {
        let dom2 = document.querySelector('#ag-item-' + this.uidarray['PrimaryResearcher']);
        if (dom2 != null) {
          dom2.removeAttribute('class');
          dom2.setAttribute(
            'style',
            `grid-area: span 3/span 4/4/2;
                    z-index:1;
                width:calc(100% - 12px);height:calc(100% - 20px);margin-top: 45px;`
          );
        } else {
          // dom2.setAttribute('class', `researcherBox 14`);
        }
      } else {
        let dom = document.querySelector('#ag-item-' + id);

        if (dom != null) dom.setAttribute('style', `grid-area: span 12/span 24/13/25;color:#CCC`);
      }

      if (this.uid == '240000') {
        //If loop for calling when secondary researcher is there
        if (`${id}` === '123456789' || `${id}` === '12345678' || `${id}` === '1234567') {
          //Update video recording start
          const resource = {
            projectRespondent_ID: this.props.respondantInfo?.projectRespondent_ID,
            cname: this.props.channel,
            //uid: String(this.uid), // can't use same UID as a user, this affects audio in recording. This UID is cloud recording
            uid: '3613483512',
            user_ID: localStorage.userId,
            clientRequest: {
              mixedVideoLayout: 3,
              // "backgroundColor": "#FF0000",
              layoutConfig: [
                {
                  uid: `${this.uidarray.RespondentOnWeb}` == '1500' ? '1500' : '1000',
                  x_axis: 0.0,
                  y_axis: 0.0,
                  width: 1.0,
                  height: 1.0,
                  alpha: 1.0,
                  render_mode: 1
                }
              ]
            }
          };
          const { UpdateLayoutVideoRecording } = this.props;
          // UpdateLayoutVideoRecording(resource, authorizationField);
          const { requestUpdateVideoLayout } = this.props;
          // UpdateLayourequestUpdateVideoLayouttVideoRecording(resource, authorizationField);
          requestUpdateVideoLayout(resource, authorizationField);

          //END
        }
      }
      // this.uidarray = this.uidarray.filter(function(item) {
      //   return console.log("item",item);
      //     //return item !== id
      // })
    }
  };

  handleSelectChange = e => {
    if (e.value == 'NA') {
      return;
    }

    setLanguage(e);
    localStorage.setItem('language', e.label);
    localStorage.setItem('languageValue', e.value);

    let lang = e.value;
    this.setState({ currentLanguage: e.label, myLanguage: lang });
    const transcriptObj = {
      text: 'Please turn on CC..!!',
      name: this.getLocalCaptionDisplayName(),
      language: lang.split('-')[0]
    };
    this.sendMsg(JSON.stringify(transcriptObj));
    this.sendToMixPanel('Lang Change', 101, 'Language changed to ' + lang);
    // this.sendDataAPi(responseObj);
    console.log('TRANSLATION RECOGNIZER', this.translationRecognizer);
    if (this.translationRecognizer != null) {
      this.translationRecognizer?.stopContinuousRecognitionAsync(async () => {
        console.log('TRANSLATION RECOGNIZER REASON');
        await this.translationRecognizer.close();

        this.sendToMixPanel('translation stopped!!!', 205, `Stopping if translator is running before start.`);

        setTimeout(() => {
          this.getTranslationRecognizer(lang, 'Language changed to ' + lang);
        }, 200);
      });
    } else {
      if (this.translationRecognizer == null) {
        this.getTranslationRecognizer(lang, 'Language changed to ' + lang);
      }
    }
  };

  // transcriptionDesign = (name,value,color) => {
  //   const baseStyle = {
  //     padding: '0.5rem', // equivalent to Bootstrap's p-2
  //     width: '25%'
  //   };

  //   const reconnectingStyle = {
  //     paddingRight: '1.5rem' // equivalent to Bootstrap's pr-4
  //   };
  //   return (
  //     <>
  //       <div
  //         className={this.state.isreconnecting ? "p-2 pr-4 w-25" : "p-2 w-25"}
  //         style={{ color, borderRight: '1px solid rgb(164, 201, 22)', width: '45px'}}
  //       >
  //         {name}
  //       </div>
  //       {((this.state.isreconnecting && (name == this.state.userName)) && (value == 'Please wait. Trying to resume captions...')&& (<div className="p-2"><PulsatingDot color='white'/></div>))}
  //       {((this.state.isreconnecting && (name == this.state.userName)) && (value == 'Failed to load. Contact support')&& (<div className="p-2"><PulsatingDot color='red'/></div>))}
  //       {
  //         (this.state.isreconnecting && (name == this.state.userName) &&(value == 'Please wait. Trying to resume captions...') ) && (
  //           <div className="text-warning p-2 w-100">{value}</div>
  //         )
  //       }
  //       {
  //         (this.state.isreconnecting && (name == this.state.userName) &&(value == 'Failed to load. Contact support') ) && (
  //           <div className="text-danger p-2 w-100">{value}</div>
  //         )
  //       }
  //       {
  //         (!this.state.isreconnecting) && (
  //           <div className="text-white p-2 w-100">{(value != 'Failed to load. Contact support' && value != 'Please wait. Trying to resume captions...') ? value : ''}</div>
  //         )
  //       }
  //       {/* {this.state.transcriptionResults == 'Resuming translation... ' ?
  //         <div className="text-white p-2 w-100"><PulsatingDot /></div>
  //         : <div className="text-white p-2 w-100">{this.state.transcriptionResults}</div>
  //       } */}
  //     </>
  //   );
  // };

  render() {
    const style = {
      display: 'flex',
      // gridGap: "25px",
      alignItems: 'center',
      justifyItems: 'center',
      gridTemplateRows: 'repeat(0, auto)',
      gridTemplateColumns: 'repeat(0, auto)',
      // width:"588px",
      flexDirection: 'columnReverse',
      // position: 'relative',
      // width: '100%',
      // height: '100%',
      // minHeight: '100vh'
    };

    const isSecondaryResearcher = this.props.respondantInfo?.isInterviewStart == 0;
    const { cameraPermissionDenied, microphonePermissionDenied } = this.state;
    const videoControlBtn =
      this.props.attendeeMode === 'video' && !isSecondaryResearcher
        ? this.props.respondantInfo?.isInterviewStart == 1 || this.props.respondantInfo?.isRead == 1
          ? (
              <DeviceButtonWrapper style={{ marginRight: '6%', gap: '8px' }}>
                {cameraPermissionDenied && (
                  <PermissionWarningIcon title="Camera permission denied">
                    <Icon style={{ fontSize: 14 }} color="#ff9800">error</Icon>
                  </PermissionWarningIcon>
                )}
                <span
                  onClick={
                    this.props.respondantInfo?.isInterviewStart == 1 || this.props.respondantInfo?.isRead == 1
                      ? this.handleCamera
                      : ''
                  }
                  className={this.props.videoinit ? 'ag-btn videoControlBtn' : 'ag-btn videoControlBtn off'}
                  title="Enable/Disable Video"
                >
                  <img src={videoOnNew} className="ag-icon ag-icon-camera" width="20px" height="20px" />
                  <img src={videoOffNew} className="ag-icon ag-icon-camera-off" width="20px" height="20px" />
                </span>
              </DeviceButtonWrapper>
            )
          : (
              <span className="ag-btn videoControlBtn1" title="Enable/Disable Video" style={{ marginRight: '6%' }}>
                <img src={videoOffNew} className="ag-icon ag-icon-camera-off" width="20px" height="20px" />
              </span>
            )
        : null;

    // const [isMicMuted, setIsMicMuted] = useState(true);

    const Tooltip = ({ text }) => {
      const tooltipStyle = {
        position: 'absolute',
        bottom: '-68%',
        left: '75%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        color: 'var(--headingColor);',
        fontWeight: 'bold',
        padding: '5px 10px',
        border: '1px solid white',
        borderRadius: '4px',
        fontSize: '14px',
        whiteSpace: 'nowrap'
      };

      return <div style={tooltipStyle}>{text}</div>;
    };

    // const tooltipWrapperStyle = {
    //   position: 'relative',
    //   display: 'inline-block'
    // };

    const styles = {
      userInfo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: '10px',
        paddingBottom: '8px',
        borderBottom: '1px solid #ccc'
      },
      avatar: {
        width: '25px',
        height: '25px',
        zindex: 1,
        transform: 'translateY(-5px)'
      },

      displayDataContainer: {
        // marginTop: '5px',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left'
      },
      displayAvatar: {
        width: '25px',
        height: '25px',
        borderRadius: '50%',
        //  marginRight: '5px',
        marginRight: '10px'
      },
      displayName: {
        color: 'var(--greyBlue)',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'left',
        lineHeight: '1.2',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },

      seeMore: {
        color: '#2361A0',
        textAlign: 'center',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '1.2',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        cursor: 'pointer'
      }
    };

    const AvatarImage = styled.img`
      margin-top: 13px;
    `;

    const AvatarContainer = styled.div`
      position: relative;
      display: flex;
      align-items: center;
    `;
    const PopupContainer = styled.div`
      position: relative;
    `;

    const { isMicMuted, active } = this.state;

    const audioControlBtn =
      this.props.attendeeMode !== 'audience' ? (
        <DeviceButtonWrapper style={{ marginRight: '6%', gap: '8px' }}>
          {microphonePermissionDenied && (
            <PermissionWarningIcon title="Microphone permission denied">
              <Icon style={{ fontSize: 14 }} color="#ff9800">error</Icon>
            </PermissionWarningIcon>
          )}
          <span
            onClick={this.handleMic}
            className={this.props.micinit ? 'ag-btn audioControlBtn' : 'ag-btn audioControlBtn off'}
            title="Enable/Disable Audio"
          >
            <img src={micOnNew} className="ag-icon ag-icon-mic" width="20px" height="20px" />
            <img src={micOffNew} className="ag-icon ag-icon-mic-off" width="20px" height="20px" />
          </span>
        </DeviceButtonWrapper>
      ) : (
        ''
      );

    const switchDisplayBtn = (
      <span
        onClick={this.switchDisplay}
        className={this.state.streamList.length > 4 ? 'ag-btn displayModeBtn disabled' : 'ag-btn displayModeBtn'}
        title="Switch Display Mode"
      >
        <i className="ag-icon ag-icon-switch-display"></i>
      </span>
    );
    const hideRemoteBtn = (
      <span
        className={
          this.state.streamList.length > 4 || this.state.displayMode !== 'pip'
            ? 'ag-btn disableRemoteBtn disabled'
            : 'ag-btn disableRemoteBtn'
        }
        onClick={this.hideRemote}
        title="Hide Remote Stream"
      >
        <i className="ag-icon ag-icon-remove-pip"></i>
      </span>
    );

    const { showModal } = this.state;
    const exitBtn = (
      <span
        // onClick={this.handleExit}
        onClick={this.handleExitClick}
        className={this.state.readyState ? 'ag-btn exitBtn' : 'ag-btn exitBtn disabled'}
        title="Exit"
      >
        {/* <i className="ag-icon ag-icon-leave"></i> */}
        <img src={endCallNew} width="60px" height="55px" className="ag-icon ag-icon-leave" />
      </span>
    );

    //   const renderWifiButton1 = () => {
    //     let color;
    //     const { networkQuality } = this.state;
    //  //   console.log("check" , this.state.networkQuality)
    //    if (networkQuality?.uplinkNetworkQuality === 1) {
    //       color = 'green';
    //     } else if (networkQuality?.uplinkNetworkQuality === 2) {
    //       color = 'yellow';
    //     } else if (networkQuality?.uplinkNetworkQuality >= 3) {
    //       color = 'red';
    //     }else
    //     {
    //       color = 'white'
    //     }

    //   // console.log("color", networkQuality)
    //     return (
    //       <span title="Network-Quality">
    //         <IoIosWifi size={30} className="ag-icon ag-icon-wifi mr-4" color={color} />
    //       </span>
    //     );

    //   }

    // const renderWifiButton1 = () => {
    //   const { iconColor } = this.state;

    //   return (
    //     <span title="Network-Quality">
    //       <GiNetworkBars size={25} className="ag-icon ag-icon-wifi mr-4" color={iconColor} />
    //     </span>
    //   );
    // };

    // translation button code
    const translationBtn =
      this.props.attendeeMode !== 'audience' ? (
        <span onClick={this.startTranslationCC} className="ag-btn" title="Enable/Disable Translation">
          <img
            src={this.state.startTranslation ? captionIcon : captionOffIcon}
            width="30px"
            height="30px"
            className="ag-icon ag-icon-caption"
          />
        </span>
      ) : (
        ''
      );

    const lang = { label: localStorage.getItem('language'), value: localStorage.getItem('languageValue') };
    setLanguage(lang);

    // language selection
    const selectLanguageBtn =
      this.props.attendeeMode !== 'audience' ? (
        <span style={{ marginLeft: '3%', marginRight: '3%' }} className="ag-btn">
          <DropdownIcon
            cssClass="dropdownIcon-button p-1"
            color="var(--snapGreen)"
            iconSrc={translationIcon}
            items={languages}
            onChange={this.handleSelectChange}
            selected={lang}
            style={{ marginTop: '3%' }}
          />
          {setLanguage(lang)}
        </span>
      ) : (
        ''
      );

    const { ParticipantsData, showPopup, showAllParticipants } = this.state;
    return (
      <>
        <div id="ag-canvas" style={style} className="d-lg-flex flex-column-reverse">
          <div className="ag-btn-group">
            <ToastContainer
              className="custom-toast-container"
              toastClassName="custom-toast-body"
              bodyClassName="custom-toast-body"
            />
            {translationBtn}
            {selectLanguageBtn}
            <div className="ag-btn">
              <div style={styles.tooltipWrapper} onClick={this.handleTogglePopup}>
                <div>
                  <PopupContainer>
                    <AvatarContainer>
                      <Badge className="badge">{this.state.participants}</Badge>

                      <AvatarImage
                        src={this.state.showParticipantsBefore ? participants : participantsoff}
                        className="mr-4"
                        style={styles.avatar}
                        alt="User Avatar"
                        onClick={this.handleToggleParticipantsImage}
                      />
                      <ParticipantsPopup
                        showed={showPopup}
                        onClose={this.handleClosePopup}
                        heading="Participants"
                        showCross={true}
                        showCancel={false}
                        showAllParticipants={showAllParticipants}
                        handleToggleParticipants={this.handleToggleParticipants}
                        ParticipantsData={ParticipantsData}
                      ></ParticipantsPopup>
                    </AvatarContainer>
                  </PopupContainer>
                </div>
              </div>
            </div>

            <Divider
              className="ag-btn"
              background="var(--greyBlue)"
              style={{ marginRight: '3%' }}
              orientation="vertical"
              height="30px"
              width="2px"
            />

            {videoControlBtn}
            {audioControlBtn}

            {active && isMicMuted && <Tooltip text="You are on mute" />}
            {
              <span
                onClick={this.sharingScreen}
                className="ag-btn shareScreenBtn"
                title="Share/unShare Screen"
                style={{ marginRight: '6%' }}
              >
                {/* <i className="ag-icon ag-icon-screen-share"></i> */}
                <img src={screenShareNew} width="18px" height="20px" />
              </span>
            }

            {exitBtn}

            <EndInterviewPopup
              onClose={this.handleCloseModal}
              showed={showModal}
              heading="Terminate the interview?"
              secondheading={
                this.props.unansweredCount > 0
                  ? `There are ${this.props.unansweredCount} required unanswered questions. Would you like to go back and answer them?.\n You will not be able to rejoin this call. Recording will be terminated.`
                  : 'You will not be able to rejoin this call. Recording will be terminated.'
              }
              showCancel={true}
              showCross={false}
            >
              <CustomButtont
                fontSize="14px"
                fontWeight="600"
                size="medium"
                style={{ justifyContent: 'space-between', marginRight: '20px' }}
                onClick={this.handleExit}
              >
                {this.props.unansweredCount > 0 ? 'Submit Anyway' : 'End Interview'}
              </CustomButtont>
            </EndInterviewPopup>
          </div>
          <div className="d-flex flex-md-column w-100 captionBox mt-2">
            {this.state.startTranslation ? (
              <>
                <div className="d-flex mt-2 w-100" style={{ fontSize: '14px' }}>
                  {this.state.transcriptionResults != '' ? (
                    <>
                      {/* {
                      this.transcriptionDesign(
                        this.state.userName,
                        this.state.transcriptionResults,
                        '#A4C916',
                      )
                    }   */}
                      <div
                        className={!this.state.isreconnecting ? 'p-2 w-25' : 'p-2 w-25'}
                        style={{ color: '#A4C916', borderRight: '1px solid rgb(164, 201, 22)', width: '15%' }}
                      >
                        {this.getLocalCaptionDisplayName()}
                      </div>
                      {/* {((this.state.isreconnecting) && (this.state.transcriptionResults == 'Please wait. Trying to resume captions...')&& (<div className="p-2" style={{position: 'relative', left: '5px'}}><PulsatingDot color='white'/></div>))} */}
                      {/* {((this.state.isreconnecting) && (this.state.transcriptionResults == 'Failed to load. Contact support')&& (<div className="p-2"><PulsatingDot color='red'/></div>))}  */}
                      {this.state.isreconnecting &&
                        this.state.transcriptionResults == 'Please wait. Trying to resume captions...' && (
                          <div className="d-flex w-100">
                            <div className="p-2">
                              <PulsatingDot color="white" />
                            </div>
                            <div className="text-warning p-2 w-80">{this.state.transcriptionResults}</div>
                          </div>
                        )}
                      {this.state.isreconnecting &&
                        this.state.transcriptionResults == 'Failed to load. Contact support' && (
                          <div className="d-flex w-100">
                            <div className="p-2">
                              <PulsatingDot color="red" />
                            </div>
                            <div className="text-danger p-2 w-80">{this.state.transcriptionResults}</div>
                          </div>
                        )}
                      {this.state.isreconnecting &&
                        this.state.transcriptionResults != 'Failed to load. Contact support' &&
                        this.state.transcriptionResults != 'Please wait. Trying to resume captions...' && (
                          <div className="text-white p-2 w-100">{this.state.transcriptionResults}</div>
                        )}
                      {!this.state.isreconnecting && (
                        <div className="text-white p-2 w-100">
                          {this.state.transcriptionResults != 'Failed to load. Contact support' &&
                          this.state.transcriptionResults != 'Please wait. Trying to resume captions...'
                            ? this.state.transcriptionResults
                            : ''}
                        </div>
                      )}
                      {/* {
                      (!this.state.isreconnecting) && (
                        <div className="text-white p-2 w-100">{(this.state.transcriptionResults != 'Failed to load. Contact support' && this.state.transcriptionResults != 'Please wait. Trying to resume captions...') ? this.state.transcriptionResults : ''}</div>
                      )
                    } */}
                    </>
                  ) : (
                    ''
                  )}
                </div>

                {this.state.displayData.map((item, index) => (
                  <div className="d-flex mt-2 w-100" style={{ fontSize: '14px' }}>
                    {item && item.text != '' && (
                      <>
                        <div
                          className="p-2 w-25"
                          style={{
                            color: `${messageBoxColor[index]}`,
                            borderRight: `1px solid ${messageBoxColor[index]}`,
                            width: '15%'
                          }}
                        >
                          {item.name}
                        </div>
                        <div className="text-white p-2 w-100">{item.text}</div>
                      </>
                    )}
                  </div>
                ))}
              </>
            ) : (
              ''
            )}
          </div>

          {this.state.showPrimaryResearcherModal && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={this.handleClosePrimaryResearcherModal}
            >
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '24px',
                  width: '90%',
                  maxWidth: '500px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                }}
                onClick={e => e.stopPropagation()}
              >
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    color: '#333',
                    textAlign: 'left',
                    lineHeight: '1.5',
                    marginBottom: '8px'
                  }}
                >
                  {this.getPrimaryResearcherDisplayName()} has still not joined the call.<br />
                  This Interview will not be analysed
                </div>
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                  <CancelButton
                    fontSize="15px"
                    fontWeight="500"
                    color="black"
                    size="large"
                    buttonColor="var(--white)"
                    onClick={this.handleContinueAnyway}
                  >
                    Continue Anyway
                  </CancelButton>
                  <CustomButtont
                    fontSize="14px"
                    fontWeight="600"
                    size="medium"
                    style={{ color: 'white', border: 'none', padding: '8px 20px' }}
                    onClick={this.handleCancelAndContactSupport}
                  >
                    Cancel & Contact Support
                  </CustomButtont>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

const ConnectedAgoraCanvas = connect(mapStateToProps, {
  VideoRecording,
  CountNoParticipant,
  StopVideoRecording,
  removeVideoCall,
  VideoRecordingUserList,
  getUIDDetails,
  VideoRecordingUpdate,
  UpdateLayoutVideoRecording,
  requestUpdateVideoLayout,
  RtcTokenBuilder,
  sendTranscriptData,
  storeTranscriptLogs,
  getParticipant,
  saveRtmTranscriptData,
  storeTranscriptMessageLogs,
  updateSid,
  SendParticpantsListOnEnd
})(AgoraCanvas);

export default ConnectedAgoraCanvas;